// LocationData.js - All 478 locations with coordinates

const allLocations = [
  {
    id: "01",
    name: "Afghanistan",
    type: "country",
    continent: "Asia",
    coordinates: [67.7090, 33.9391],
    flag: "🇦🇫",
    officeType: "regional",
    population: "39.8 million",
    status: "planned"
  },
  {
    id: "02",
    name: "Albania",
    type: "country",
    continent: "Europe",
    coordinates: [20.1683, 41.1533],
    flag: "🇦🇱",
    officeType: "regional",
    population: "2.9 million",
    status: "planned"
  },
  {
    id: "03",
    name: "Algeria",
    type: "country",
    continent: "Africa",
    coordinates: [1.6596, 28.0339],
    flag: "🇩🇿",
    officeType: "regional",
    population: "44.9 million",
    status: "planned"
  },
  {
    id: "04",
    name: "American Samoa",
    type: "territory",
    country: "United States",
    continent: "Oceania",
    coordinates: [-170.1320, -14.2710],
    flag: "🇦🇸",
    officeType: "territorial",
    population: "46,000",
    status: "planned"
  },
  {
    id: "05",
    name: "Andorra",
    type: "country",
    continent: "Europe",
    coordinates: [1.6016, 42.5063],
    flag: "🇦🇩",
    officeType: "regional",
    population: "77,000",
    status: "planned"
  },
  {
    id: "06",
    name: "Angola",
    type: "country",
    continent: "Africa",
    coordinates: [17.8739, -11.2027],
    flag: "🇦🇴",
    officeType: "regional",
    population: "33.9 million",
    status: "planned"
  },
  {
    id: "07",
    name: "Anguilla",
    type: "territory",
    country: "United Kingdom",
    continent: "North America",
    coordinates: [-63.0686, 18.2206],
    flag: "🇦🇮",
    officeType: "territorial",
    population: "15,000",
    status: "planned"
  },
  {
    id: "08",
    name: "Antigua and Barbuda",
    type: "country",
    continent: "North America",
    coordinates: [-61.7964, 17.0608],
    flag: "🇦🇬",
    officeType: "regional",
    population: "98,000",
    status: "planned"
  },
  {
    id: "09",
    name: "Argentina",
    type: "country",
    continent: "South America",
    coordinates: [-63.6167, -38.4161],
    flag: "🇦🇷",
    officeType: "regional",
    population: "45.8 million",
    status: "planned"
  },
  {
    id: "10",
    name: "Armenia",
    type: "country",
    continent: "Asia",
    coordinates: [45.0382, 40.0691],
    flag: "🇦🇲",
    officeType: "regional",
    population: "3.0 million",
    status: "planned"
  },
  {
    id: "11",
    name: "Aruba",
    type: "territory",
    country: "Netherlands",
    continent: "North America",
    coordinates: [-69.9312, 12.5211],
    flag: "🇦🇼",
    officeType: "territorial",
    population: "107,000",
    status: "planned"
  },
  {
    id: "12",
    name: "AU Australian Capital Territory",
    type: "territory",
    country: "Australia",
    continent: "Oceania",
    coordinates: [149.1300, -35.4735],
    flag: "🇦🇺",
    officeType: "territory",
    population: "461,000",
    capital: "Canberra",
    status: "planned"
  },
  {
    id: "13",
    name: "AU New South Wales",
    type: "state",
    country: "Australia",
    continent: "Oceania",
    coordinates: [147.2093, -33.7975],
    flag: "🇦🇺",
    officeType: "state",
    population: "8.2 million",
    capital: "Sydney",
    status: "planned"
  },
  {
    id: "14",
    name: "AU Northern Territory",
    type: "territory",
    country: "Australia",
    continent: "Oceania",
    coordinates: [133.8807, -19.4914],
    flag: "🇦🇺",
    officeType: "territory",
    population: "249,000",
    capital: "Darwin",
    status: "planned"
  },
  {
    id: "15",
    name: "AU Queensland",
    type: "state",
    country: "Australia",
    continent: "Oceania",
    coordinates: [142.7028, -22.7309],
    flag: "🇦🇺",
    officeType: "state",
    population: "5.2 million",
    capital: "Brisbane",
    status: "planned"
  },
  {
    id: "16",
    name: "AU South Australia",
    type: "state",
    country: "Australia",
    continent: "Oceania",
    coordinates: [135.7781, -30.0002],
    flag: "🇦🇺",
    officeType: "state",
    population: "1.8 million",
    capital: "Adelaide",
    status: "planned"
  },
  {
    id: "17",
    name: "AU Tasmania",
    type: "state",
    country: "Australia",
    continent: "Oceania",
    coordinates: [146.3070, -41.6400],
    flag: "🇦🇺",
    officeType: "state",
    population: "541,000",
    capital: "Hobart",
    status: "planned"
  },
  {
    id: "18",
    name: "AU Victoria",
    type: "state",
    country: "Australia",
    continent: "Oceania",
    coordinates: [144.2085, -36.5986],
    flag: "🇦🇺",
    officeType: "state",
    population: "6.7 million",
    capital: "Melbourne",
    status: "planned"
  },
  {
    id: "19",
    name: "AU Western Australia",
    type: "state",
    country: "Australia",
    continent: "Oceania",
    coordinates: [121.6283, -25.2744],
    flag: "🇦🇺",
    officeType: "state",
    population: "2.7 million",
    capital: "Perth",
    status: "planned"
  },
  {
    id: "20",
    name: "Australia",
    type: "country",
    continent: "Oceania",
    coordinates: [133.7751, -25.2744],
    flag: "🇦🇺",
    officeType: "regional",
    population: "25.7 million",
    status: "planned"
  },
  {
    id: "21",
    name: "Austria",
    type: "country",
    continent: "Europe",
    coordinates: [14.5501, 47.5162],
    flag: "🇦🇹",
    officeType: "regional",
    population: "9.0 million",
    status: "planned"
  },
  {
    id: "22",
    name: "Azerbaijan",
    type: "country",
    continent: "Asia",
    coordinates: [47.5769, 40.1431],
    flag: "🇦🇿",
    officeType: "regional",
    population: "10.1 million",
    status: "planned"
  },
  {
    id: "23",
    name: "Azores",
    type: "region",
    country: "Portugal",
    continent: "Europe",
    coordinates: [-25.7667, 37.7412],
    flag: "🇵🇹",
    officeType: "autonomous_region",
    population: "236,000",
    status: "planned"
  },
  {
    id: "24",
    name: "Bahrain",
    type: "country",
    continent: "Asia",
    coordinates: [50.6373, 25.9304],
    flag: "🇧🇭",
    officeType: "regional",
    population: "1.7 million",
    status: "planned"
  },
  {
    id: "25",
    name: "Bangladesh",
    type: "country",
    continent: "Asia",
    coordinates: [90.3563, 23.6850],
    flag: "🇧🇩",
    officeType: "regional",
    population: "166 million",
    status: "planned"
  },
  {
    id: "26",
    name: "Barbados",
    type: "country",
    continent: "North America",
    coordinates: [-59.5432, 13.1939],
    flag: "🇧🇧",
    officeType: "regional",
    population: "288,000",
    status: "planned"
  },
  {
    id: "27",
    name: "Belarus",
    type: "country",
    continent: "Europe",
    coordinates: [27.9534, 53.7098],
    flag: "🇧🇾",
    officeType: "regional",
    population: "9.5 million",
    status: "planned"
  },
  {
    id: "28",
    name: "Belgium",
    type: "country",
    continent: "Europe",
    coordinates: [4.4699, 50.5039],
    flag: "🇧🇪",
    officeType: "regional",
    population: "11.6 million",
    status: "active"
  },
  {
    id: "29",
    name: "Belize",
    type: "country",
    continent: "North America",
    coordinates: [-88.4976, 17.1899],
    flag: "🇧🇿",
    officeType: "regional",
    population: "405,000",
    status: "planned"
  },
  {
    id: "30",
    name: "Benin",
    type: "country",
    continent: "Africa",
    coordinates: [2.3158, 9.3077],
    flag: "🇧🇯",
    officeType: "regional",
    population: "12.5 million",
    status: "planned"
  },
  {
    id: "31",
    name: "Bermuda",
    type: "territory",
    country: "United Kingdom",
    continent: "North America",
    coordinates: [-64.7505, 32.3078],
    flag: "🇧🇲",
    officeType: "territorial",
    population: "64,000",
    status: "planned"
  },
  {
    id: "32",
    name: "Bhutan",
    type: "country",
    continent: "Asia",
    coordinates: [90.4336, 27.5142],
    flag: "🇧🇹",
    officeType: "regional",
    population: "775,000",
    status: "planned"
  },
  {
    id: "33",
    name: "Bolivia",
    type: "country",
    continent: "South America",
    coordinates: [-63.5887, -16.2902],
    flag: "🇧🇴",
    officeType: "regional",
    population: "11.8 million",
    status: "planned"
  },
  {
    id: "34",
    name: "Bonaire",
    type: "territory",
    country: "Netherlands",
    continent: "North America",
    coordinates: [-68.2624, 12.1784],
    flag: "🇧🇶",
    officeType: "territorial",
    population: "21,000",
    status: "planned"
  },
  {
    id: "35",
    name: "Bosnia Herzegovina",
    type: "country",
    continent: "Europe",
    coordinates: [17.6791, 43.9159],
    flag: "🇬🇧",
    officeType: "regional",
    population: "3.3 million",
    status: "planned"
  },
  {
    id: "36",
    name: "Botswana",
    type: "country",
    continent: "Africa",
    coordinates: [24.6849, -22.3285],
    flag: "🇧🇼",
    officeType: "regional",
    population: "2.4 million",
    status: "planned"
  },
  {
    id: "37",
    name: "BR Central West Brazil",
    type: "region",
    country: "Brazil",
    continent: "South America",
    coordinates: [-55.0000, -15.0000],
    flag: "🇧🇷",
    officeType: "regional",
    population: "16.0 million",
    status: "planned"
  },
  {
    id: "38",
    name: "BR North Brazil",
    type: "region",
    country: "Brazil",
    continent: "South America",
    coordinates: [-60.0000, -3.0000],
    flag: "🇧🇷",
    officeType: "regional",
    population: "18.0 million",
    status: "planned"
  },
  {
    id: "39",
    name: "BR Northeast Brazil",
    type: "region",
    country: "Brazil",
    continent: "South America",
    coordinates: [-38.0000, -9.0000],
    flag: "🇬🇧",
    officeType: "region",
    population: "57.0 million",
    status: "planned"
  },
  {
    id: "40",
    name: "BR South Brazil",
    type: "region",
    country: "Brazil",
    continent: "South America",
    coordinates: [-51.0000, -28.0000],
    flag: "🇧🇷",
    officeType: "regional",
    population: "30.0 million",
    status: "planned"
  },
  {
    id: "41",
    name: "BR Southeast Brazil",
    type: "region",
    country: "Brazil",
    continent: "South America",
    coordinates: [-45.0000, -20.0000],
    flag: "🇧🇷",
    officeType: "regional",
    population: "89.0 million",
    status: "planned"
  },
  {
    id: "42",
    name: "British Virgin Islands",
    type: "territory",
    country: "United Kingdom",
    continent: "North America",
    coordinates: [-64.5912, 18.4207],
    flag: "🇻🇬",
    officeType: "territorial",
    population: "31,000",
    status: "planned"
  },
  {
    id: "43",
    name: "Brunei Darussalam",
    type: "country",
    continent: "Asia",
    coordinates: [114.7277, 4.5353],
    flag: "🇧🇳",
    officeType: "regional",
    population: "441,000",
    status: "planned"
  },
  {
    id: "44",
    name: "Bulgaria",
    type: "country",
    continent: "Europe",
    coordinates: [25.4858, 42.7339],
    flag: "🇧🇬",
    officeType: "regional",
    population: "6.9 million",
    status: "planned"
  },
  {
    id: "45",
    name: "Burkina Faso",
    type: "country",
    continent: "Africa",
    coordinates: [-2.1846, 12.2383],
    flag: "🇧🇫",
    officeType: "regional",
    population: "22.1 million",
    status: "planned"
  },
  {
    id: "46",
    name: "Burundi",
    type: "country",
    continent: "Africa",
    coordinates: [29.9189, -3.3731],
    flag: "🇧🇮",
    officeType: "regional",
    population: "12.6 million",
    status: "planned"
  },
  {
    id: "47",
    name: "CA Alberta",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-113.4909, 53.9333],
    flag: "🇨🇦",
    officeType: "province",
    population: "4.4 million",
    capital: "Edmonton",
    status: "planned"
  },
  {
    id: "48",
    name: "CA British Colombia",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-126.2500, 53.7267],
    flag: "🇨🇦",
    officeType: "province",
    population: "5.2 million",
    capital: "Victoria",
    status: "planned"
  },
  {
    id: "49",
    name: "CA Manitoba",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-98.7396, 53.7609],
    flag: "🇨🇦",
    officeType: "province",
    population: "1.4 million",
    capital: "Winnipeg",
    status: "planned"
  },
  {
    id: "50",
    name: "CA New Brunswick",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-66.1620, 46.5653],
    flag: "🇨🇦",
    officeType: "province",
    population: "781,000",
    capital: "Fredericton",
    status: "planned"
  },
  {
    id: "51",
    name: "CA Newfoundland and Labrador",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-57.6604, 53.1355],
    flag: "🇨🇦",
    officeType: "province",
    population: "521,000",
    capital: "St. John's",
    status: "planned"
  },
  {
    id: "52",
    name: "CA Northwest Territories",
    type: "territory",
    country: "Canada",
    continent: "North America",
    coordinates: [-117.0000, 64.0000],
    flag: "🇨🇦",
    officeType: "territory",
    population: "45,000",
    capital: "Yellowknife",
    status: "planned"
  },
  {
    id: "53",
    name: "CA Nova Scotia",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-63.7443, 44.6820],
    flag: "🇨🇦",
    officeType: "province",
    population: "992,000",
    capital: "Halifax",
    status: "planned"
  },
  {
    id: "54",
    name: "CA Nunavut",
    type: "territory",
    country: "Canada",
    continent: "North America",
    coordinates: [-85.0000, 70.0000],
    flag: "🇨🇦",
    officeType: "territory",
    population: "39,000",
    capital: "Iqaluit",
    status: "planned"
  },
  {
    id: "55",
    name: "CA Ontario",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-85.0000, 50.0000],
    flag: "🇨🇦",
    officeType: "province",
    population: "14.7 million",
    capital: "Toronto",
    status: "planned"
  },
  {
    id: "56",
    name: "CA Prince Edward Island",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-63.1311, 46.5107],
    flag: "🇨🇦",
    officeType: "province",
    population: "159,000",
    capital: "Charlottetown",
    status: "planned"
  },
  {
    id: "57",
    name: "CA Quebec",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-71.2080, 46.8139],
    flag: "🇨🇦",
    officeType: "province",
    population: "8.6 million",
    capital: "Quebec City",
    status: "planned"
  },
  {
    id: "58",
    name: "CA Saskatchewan",
    type: "province",
    country: "Canada",
    continent: "North America",
    coordinates: [-106.3468, 52.9399],
    flag: "🇨🇦",
    officeType: "province",
    population: "1.2 million",
    capital: "Regina",
    status: "planned"
  },
  {
    id: "59",
    name: "CA Yukon",
    type: "territory",
    country: "Canada",
    continent: "North America",
    coordinates: [-135.0000, 64.0000],
    flag: "🇨🇦",
    officeType: "territory",
    population: "42,000",
    capital: "Whitehorse",
    status: "planned"
  },
  {
    id: "60",
    name: "Cabo Verde",
    type: "country",
    continent: "Africa",
    coordinates: [-24.0132, 16.5388],
    flag: "🇨🇻",
    officeType: "regional",
    population: "561,000",
    status: "planned"
  },
  {
    id: "61",
    name: "Cambodia",
    type: "country",
    continent: "Asia",
    coordinates: [104.9910, 12.5657],
    flag: "🇰🇭",
    officeType: "regional",
    population: "16.7 million",
    status: "planned"
  },
  {
    id: "62",
    name: "Cameroon",
    type: "country",
    continent: "Africa",
    coordinates: [12.3547, 7.3697],
    flag: "🇨🇲",
    officeType: "regional",
    population: "27.2 million",
    status: "planned"
  },
  {
    id: "63",
    name: "Cayman Islands",
    type: "territory",
    country: "United Kingdom",
    continent: "North America",
    coordinates: [-80.5665, 19.3133],
    flag: "🇰🇾",
    officeType: "territorial",
    population: "68,000",
    status: "planned"
  },
  {
    id: "64",
    name: "Central African Republic",
    type: "country",
    continent: "Africa",
    coordinates: [20.9394, 6.6111],
    flag: "🇨🇫",
    officeType: "regional",
    population: "4.8 million",
    status: "planned"
  },
  {
    id: "65",
    name: "Chad",
    type: "country",
    continent: "Africa",
    coordinates: [18.7322, 15.4542],
    flag: "🇹🇩",
    officeType: "regional",
    population: "16.8 million",
    status: "planned"
  },
  {
    id: "66",
    name: "Chile",
    type: "country",
    continent: "South America",
    coordinates: [-71.5430, -35.6751],
    flag: "🇨🇱",
    officeType: "regional",
    population: "19.2 million",
    status: "planned"
  },
  {
    id: "67",
    name: "Christmas Island",
    type: "territory",
    country: "Australia",
    continent: "Asia",
    coordinates: [105.6904, -10.4475],
    flag: "🇨🇽",
    officeType: "territorial",
    population: "1,900",
    status: "planned"
  },
  {
    id: "68",
    name: "CN Anhui",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [117.3000, 31.8612],
    flag: "🇨🇳",
    officeType: "province",
    population: "61.0 million",
    capital: "Hefei",
    status: "planned"
  },
  {
    id: "69",
    name: "CN Beijing",
    type: "municipality",
    country: "China",
    continent: "Asia",
    coordinates: [116.4074, 39.9042],
    flag: "🇨🇳",
    officeType: "municipality",
    population: "21.5 million",
    status: "planned"
  },
  {
    id: "70",
    name: "CN Chongqing",
    type: "municipality",
    country: "China",
    continent: "Asia",
    coordinates: [106.5048, 29.5330],
    flag: "🇨🇳",
    officeType: "municipality",
    population: "32.1 million",
    status: "planned"
  },
  {
    id: "71",
    name: "CN Fujian",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [119.3000, 26.0789],
    flag: "🇨🇳",
    officeType: "province",
    population: "41.5 million",
    capital: "Fuzhou",
    status: "planned"
  },
  {
    id: "72",
    name: "CN Gansu",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [103.8236, 36.0581],
    flag: "🇨🇳",
    officeType: "province",
    population: "25.0 million",
    capital: "Lanzhou",
    status: "planned"
  },
  {
    id: "73",
    name: "CN Guangdong",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [113.2644, 23.1291],
    flag: "🇨🇳",
    officeType: "province",
    population: "126.0 million",
    capital: "Guangzhou",
    status: "planned"
  },
  {
    id: "74",
    name: "CN Guangxi",
    type: "region",
    country: "China",
    continent: "Asia",
    coordinates: [108.3669, 22.8150],
    flag: "🇨🇳",
    officeType: "autonomous_region",
    population: "50.1 million",
    capital: "Nanning",
    status: "planned"
  },
  {
    id: "75",
    name: "CN Guizhou",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [106.7135, 26.5783],
    flag: "🇨🇳",
    officeType: "province",
    population: "38.6 million",
    capital: "Guiyang",
    status: "planned"
  },
  {
    id: "76",
    name: "CN Hainan",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [110.3312, 20.0174],
    flag: "🇨🇳",
    officeType: "province",
    population: "10.1 million",
    capital: "Haikou",
    status: "planned"
  },
  {
    id: "77",
    name: "CN Hebei",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [114.5149, 38.0428],
    flag: "🇨🇳",
    officeType: "province",
    population: "74.6 million",
    capital: "Shijiazhuang",
    status: "planned"
  },
  {
    id: "78",
    name: "CN Heilongjiang",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [127.9688, 47.8864],
    flag: "🇨🇳",
    officeType: "province",
    population: "31.9 million",
    capital: "Harbin",
    status: "planned"
  },
  {
    id: "79",
    name: "CN Henan",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [113.6401, 34.7566],
    flag: "🇨🇳",
    officeType: "province",
    population: "99.4 million",
    capital: "Zhengzhou",
    status: "planned"
  },
  {
    id: "80",
    name: "CN Hubei",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [114.2982, 30.5928],
    flag: "🇨🇳",
    officeType: "province",
    population: "57.8 million",
    capital: "Wuhan",
    status: "planned"
  },
  {
    id: "81",
    name: "CN Hunan",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [112.9820, 27.6950],
    flag: "🇨🇳",
    officeType: "province",
    population: "66.4 million",
    capital: "Changsha",
    status: "planned"
  },
  {
    id: "82",
    name: "CN Inner Mongolia",
    type: "region",
    country: "China",
    continent: "Asia",
    coordinates: [111.9917, 40.8173],
    flag: "🇨🇳",
    officeType: "autonomous_region",
    population: "24.0 million",
    capital: "Hohhot",
    status: "planned"
  },
  {
    id: "83",
    name: "CN Jiangsu",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [118.7633, 32.0617],
    flag: "🇨🇳",
    officeType: "province",
    population: "84.7 million",
    capital: "Nanjing",
    status: "planned"
  },
  {
    id: "84",
    name: "CN Jiangxi",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [115.8999, 27.6140],
    flag: "🇨🇳",
    officeType: "province",
    population: "45.2 million",
    capital: "Nanchang",
    status: "planned"
  },
  {
    id: "85",
    name: "CN Jilin",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [125.3245, 43.8868],
    flag: "🇨🇳",
    officeType: "province",
    population: "24.1 million",
    capital: "Changchun",
    status: "planned"
  },
  {
    id: "86",
    name: "CN Liaoning",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [123.4291, 41.8057],
    flag: "🇨🇳",
    officeType: "province",
    population: "42.6 million",
    capital: "Shenyang",
    status: "planned"
  },
  {
    id: "87",
    name: "CN Ningxia",
    type: "region",
    country: "China",
    continent: "Asia",
    coordinates: [106.2581, 38.4722],
    flag: "🇨🇳",
    officeType: "autonomous_region",
    population: "7.2 million",
    capital: "Yinchuan",
    status: "planned"
  },
  {
    id: "88",
    name: "CN Qinghai",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [96.0026, 35.7452],
    flag: "🇨🇳",
    officeType: "province",
    population: "5.9 million",
    capital: "Xining",
    status: "planned"
  },
  {
    id: "89",
    name: "CN Shaanxi",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [108.1162, 34.2004],
    flag: "🇨🇳",
    officeType: "province",
    population: "39.5 million",
    capital: "Xi'an",
    status: "planned"
  },
  {
    id: "90",
    name: "CN Shandong",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [118.0004, 36.6758],
    flag: "🇨🇳",
    officeType: "province",
    population: "101.5 million",
    capital: "Jinan",
    status: "planned"
  },
  {
    id: "91",
    name: "CN Shanghai",
    type: "municipality",
    country: "China",
    continent: "Asia",
    coordinates: [121.4737, 31.2304],
    flag: "🇨🇳",
    officeType: "municipality",
    population: "24.9 million",
    status: "planned"
  },
  {
    id: "92",
    name: "CN Shanxi",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [112.5489, 37.8570],
    flag: "🇨🇳",
    officeType: "province",
    population: "34.9 million",
    capital: "Taiyuan",
    status: "planned"
  },
  {
    id: "93",
    name: "CN Sichuan",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [104.0648, 30.6171],
    flag: "🇨🇳",
    officeType: "province",
    population: "83.7 million",
    capital: "Chengdu",
    status: "planned"
  },
  {
    id: "94",
    name: "CN Tianjin",
    type: "municipality",
    country: "China",
    continent: "Asia",
    coordinates: [117.3616, 39.3434],
    flag: "🇨🇳",
    officeType: "municipality",
    population: "13.9 million",
    status: "planned"
  },
  {
    id: "95",
    name: "CN Tibet",
    type: "region",
    country: "China",
    continent: "Asia",
    coordinates: [88.7879, 31.6927],
    flag: "🇨🇳",
    officeType: "autonomous_region",
    population: "3.6 million",
    capital: "Lhasa",
    status: "planned"
  },
  {
    id: "96",
    name: "CN Xinjiang",
    type: "region",
    country: "China",
    continent: "Asia",
    coordinates: [85.2401, 41.7483],
    flag: "🇨🇳",
    officeType: "autonomous_region",
    population: "25.9 million",
    capital: "Urumqi",
    status: "planned"
  },
  {
    id: "97",
    name: "CN Yunnan",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [101.8652, 25.1807],
    flag: "🇨🇳",
    officeType: "province",
    population: "47.2 million",
    capital: "Kunming",
    status: "planned"
  },
  {
    id: "98",
    name: "CN Zhejiang",
    type: "province",
    country: "China",
    continent: "Asia",
    coordinates: [120.1536, 30.2741],
    flag: "🇨🇳",
    officeType: "province",
    population: "64.6 million",
    capital: "Hangzhou",
    status: "planned"
  },
  {
    id: "99",
    name: "Cocos Islands",
    type: "territory",
    country: "Australia",
    continent: "Asia",
    coordinates: [96.8349, -12.1642],
    flag: "🇨🇨",
    officeType: "territorial",
    population: "550",
    status: "planned"
  },
  {
    id: "100",
    name: "Colombia",
    type: "country",
    continent: "South America",
    coordinates: [-74.2973, 4.5709],
    flag: "🇨🇴",
    officeType: "regional",
    population: "51.3 million",
    status: "planned"
  },
  {
    id: "101",
    name: "Comoros",
    type: "country",
    continent: "Africa",
    coordinates: [43.8722, -11.8750],
    flag: "🇰🇲",
    officeType: "regional",
    population: "0.9 million",
    status: "planned"
  },
  {
    id: "102",
    name: "Cook Islands",
    type: "territory",
    country: "New Zealand",
    continent: "Oceania",
    coordinates: [-159.7777, -21.2367],
    flag: "🇨🇰",
    officeType: "territorial",
    population: "17,500",
    status: "planned"
  },
  {
    id: "103",
    name: "Costa Rica",
    type: "country",
    continent: "North America",
    coordinates: [-83.7534, 9.7489],
    flag: "🇨🇷",
    officeType: "regional",
    population: "5.1 million",
    status: "planned"
  },
  {
    id: "104",
    name: "Cote d'Ivoire",
    type: "country",
    continent: "Africa",
    coordinates: [-5.5471, 7.5400],
    flag: "🇨🇮",
    officeType: "regional",
    population: "27.5 million",
    status: "planned"
  },
  {
    id: "105",
    name: "Croatia",
    type: "country",
    continent: "Europe",
    coordinates: [15.2000, 45.1000],
    flag: "🇭🇷",
    officeType: "regional",
    population: "4.0 million",
    status: "planned"
  },
  {
    id: "106",
    name: "Cuba",
    type: "country",
    continent: "North America",
    coordinates: [-77.7812, 21.5218],
    flag: "🇨🇺",
    officeType: "regional",
    population: "11.3 million",
    status: "planned"
  },
  {
    id: "107",
    name: "Curacao",
    type: "territory",
    country: "Netherlands",
    continent: "North America",
    coordinates: [-68.9335, 12.1696],
    flag: "🇨🇼",
    officeType: "territorial",
    population: "164,000",
    status: "active"
  },
  {
    id: "108",
    name: "Cyprus",
    type: "country",
    continent: "Asia",
    coordinates: [33.4299, 35.1264],
    flag: "🇨🇾",
    officeType: "regional",
    population: "1.2 million",
    status: "planned"
  },
  {
    id: "109",
    name: "Czech Republic",
    type: "country",
    continent: "Europe",
    coordinates: [15.4730, 49.8175],
    flag: "🇨🇿",
    officeType: "regional",
    population: "10.7 million",
    status: "planned"
  },
  {
    id: "110",
    name: "DE Baden-Württemberg",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [9.0000, 48.6616],
    flag: "🇩🇪",
    officeType: "state",
    population: "11.1 million",
    capital: "Stuttgart",
    status: "planned"
  },
  {
    id: "111",
    name: "DE Bavaria",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [11.4979, 48.7904],
    flag: "🇩🇪",
    officeType: "state",
    population: "13.1 million",
    capital: "Munich",
    status: "planned"
  },
  {
    id: "112",
    name: "DE Berlin",
    type: "city_state",
    country: "Germany",
    continent: "Europe",
    coordinates: [13.4050, 52.5200],
    flag: "🇩🇪",
    officeType: "city_state",
    population: "3.7 million",
    status: "planned"
  },
  {
    id: "113",
    name: "DE Brandenburg",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [13.0059, 52.4125],
    flag: "🇩🇪",
    officeType: "state",
    population: "2.5 million",
    capital: "Potsdam",
    status: "planned"
  },
  {
    id: "114",
    name: "DE Bremen",
    type: "city_state",
    country: "Germany",
    continent: "Europe",
    coordinates: [8.8017, 53.0793],
    flag: "🇩🇪",
    officeType: "city_state",
    population: "681,000",
    status: "planned"
  },
  {
    id: "115",
    name: "DE Hamburg",
    type: "city_state",
    country: "Germany",
    continent: "Europe",
    coordinates: [9.9937, 53.5511],
    flag: "🇩🇪",
    officeType: "city_state",
    population: "1.9 million",
    status: "planned"
  },
  {
    id: "116",
    name: "DE Hesse",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [9.0000, 50.6521],
    flag: "🇩🇪",
    officeType: "state",
    population: "6.3 million",
    capital: "Wiesbaden",
    status: "planned"
  },
  {
    id: "117",
    name: "DE Lower Saxony",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [9.8467, 52.6367],
    flag: "🇩🇪",
    officeType: "state",
    population: "8.0 million",
    capital: "Hanover",
    status: "planned"
  },
  {
    id: "118",
    name: "DE Mecklenburg-Vorpommern",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [12.4282, 53.6127],
    flag: "🇩🇪",
    officeType: "state",
    population: "1.6 million",
    capital: "Schwerin",
    status: "planned"
  },
  {
    id: "119",
    name: "DE North Rhine-Westphalia",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [7.6261, 51.4332],
    flag: "🇩🇪",
    officeType: "state",
    population: "17.9 million",
    capital: "Düsseldorf",
    status: "planned"
  },
  {
    id: "120",
    name: "DE Rhineland-Palatinate",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [7.4653, 50.1180],
    flag: "🇩🇪",
    officeType: "state",
    population: "4.1 million",
    capital: "Mainz",
    status: "planned"
  },
  {
    id: "121",
    name: "DE Saarland",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [6.9956, 49.3964],
    flag: "🇩🇪",
    officeType: "state",
    population: "991,000",
    capital: "Saarbrücken",
    status: "planned"
  },
  {
    id: "122",
    name: "DE Saxony",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [13.2017, 51.1045],
    flag: "🇩🇪",
    officeType: "state",
    population: "4.1 million",
    capital: "Dresden",
    status: "planned"
  },
  {
    id: "123",
    name: "DE Saxony-Anhalt",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [11.4158, 51.9503],
    flag: "🇩🇪",
    officeType: "state",
    population: "2.2 million",
    capital: "Magdeburg",
    status: "planned"
  },
  {
    id: "124",
    name: "DE Schleswig-Holstein",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [9.6917, 54.2194],
    flag: "🇩🇪",
    officeType: "state",
    population: "2.9 million",
    capital: "Kiel",
    status: "planned"
  },
  {
    id: "125",
    name: "DE Thuringia",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [10.7850, 50.9848],
    flag: "🇩🇪",
    officeType: "state",
    population: "2.1 million",
    capital: "Erfurt",
    status: "planned"
  },
  {
    id: "126",
    name: "Democratic Republic of Congo",
    type: "country",
    continent: "Africa",
    coordinates: [21.7587, -4.0383],
    flag: "🇨🇩",
    officeType: "regional",
    population: "95.9 million",
    status: "planned"
  },
  {
    id: "127",
    name: "Denmark",
    type: "country",
    continent: "Europe",
    coordinates: [9.5018, 56.2639],
    flag: "🇩🇰",
    officeType: "regional",
    population: "5.8 million",
    status: "planned"
  },
  {
    id: "128",
    name: "Djibouti",
    type: "country",
    continent: "Africa",
    coordinates: [42.5903, 11.8251],
    flag: "🇩🇯",
    officeType: "regional",
    population: "1.0 million",
    status: "planned"
  },
  {
    id: "129",
    name: "Dominica",
    type: "country",
    continent: "North America",
    coordinates: [-61.3700, 15.4150],
    flag: "🇩🇲",
    officeType: "regional",
    population: "72,000",
    status: "planned"
  },
  {
    id: "130",
    name: "Dominican Republic",
    type: "country",
    continent: "North America",
    coordinates: [-70.1627, 18.7357],
    flag: "🇩🇴",
    officeType: "regional",
    population: "10.9 million",
    status: "active"
  },
  {
    id: "131",
    name: "ES Andalusia",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-4.5000, 37.6000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "8.4 million",
    capital: "Seville",
    status: "planned"
  },
  {
    id: "132",
    name: "ES Aragon",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-1.0000, 41.0000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "1.3 million",
    capital: "Zaragoza",
    status: "planned"
  },
  {
    id: "133",
    name: "ES Asturias",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-6.0000, 43.5000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "1.0 million",
    capital: "Oviedo",
    status: "planned"
  },
  {
    id: "134",
    name: "ES Balearic Islands",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [2.9540, 39.6953],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "1.2 million",
    capital: "Palma",
    status: "planned"
  },
  {
    id: "135",
    name: "ES Basque Country",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-2.7500, 43.0000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "2.2 million",
    capital: "Vitoria-Gasteiz",
    status: "planned"
  },
  {
    id: "136",
    name: "ES Canary Islands",
    type: "region",
    country: "Spain",
    continent: "Africa",
    coordinates: [-15.5000, 28.0000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "2.2 million",
    capital: "Las Palmas / Santa Cruz",
    status: "planned"
  },
  {
    id: "137",
    name: "ES Cantabria",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-4.0000, 43.2000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "582,000",
    capital: "Santander",
    status: "planned"
  },
  {
    id: "138",
    name: "ES Castile and León",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-5.5000, 41.8000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "2.4 million",
    capital: "Valladolid",
    status: "planned"
  },
  {
    id: "139",
    name: "ES Castilla–La Mancha",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-3.0000, 39.5000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "2.0 million",
    capital: "Toledo",
    status: "planned"
  },
  {
    id: "140",
    name: "ES Catalonia",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [1.5000, 41.8000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "7.7 million",
    capital: "Barcelona",
    status: "planned"
  },
  {
    id: "141",
    name: "ES Ceuta",
    type: "city",
    country: "Spain",
    continent: "Africa",
    coordinates: [-5.3203, 35.8883],
    flag: "🇪🇸",
    officeType: "autonomous_city",
    population: "85,000",
    status: "planned"
  },
  {
    id: "142",
    name: "ES Extremadura",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-6.0000, 39.0000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "1.1 million",
    capital: "Mérida",
    status: "planned"
  },
  {
    id: "143",
    name: "ES Galicia",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-7.8567, 42.7593],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "2.7 million",
    capital: "Santiago de Compostela",
    status: "planned"
  },
  {
    id: "144",
    name: "ES La Rioja",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-2.4450, 42.2871],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "315,000",
    capital: "Logroño",
    status: "planned"
  },
  {
    id: "145",
    name: "ES Madrid",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-3.7492, 40.4637],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "6.8 million",
    capital: "Madrid",
    status: "planned"
  },
  {
    id: "146",
    name: "ES Melilla",
    type: "city",
    country: "Spain",
    continent: "Africa",
    coordinates: [-2.9585, 35.2919],
    flag: "🇪🇸",
    officeType: "autonomous_city",
    population: "87,000",
    status: "planned"
  },
  {
    id: "147",
    name: "ES Murcia",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-1.1307, 37.9922],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "1.5 million",
    capital: "Murcia",
    status: "planned"
  },
  {
    id: "148",
    name: "ES Navarre",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-1.6500, 42.6954],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "654,000",
    capital: "Pamplona",
    status: "planned"
  },
  {
    id: "149",
    name: "ES Valencia",
    type: "region",
    country: "Spain",
    continent: "Europe",
    coordinates: [-0.5000, 39.5000],
    flag: "🇪🇸",
    officeType: "autonomous_community",
    population: "5.0 million",
    capital: "Valencia",
    status: "planned"
  },
  {
    id: "150",
    name: "Ecuador",
    type: "country",
    continent: "South America",
    coordinates: [-78.1834, -1.8312],
    flag: "🇪🇨",
    officeType: "regional",
    population: "17.8 million",
    status: "planned"
  },
  {
    id: "151",
    name: "Egypt",
    type: "country",
    continent: "Africa",
    coordinates: [30.8025, 26.8206],
    flag: "🇪🇬",
    officeType: "regional",
    population: "104 million",
    status: "planned"
  },
  {
    id: "152",
    name: "El Salvador",
    type: "country",
    continent: "North America",
    coordinates: [-88.8965, 13.7942],
    flag: "🇸🇻",
    officeType: "regional",
    population: "6.5 million",
    status: "planned"
  },
  {
    id: "153",
    name: "Equatorial Guinea",
    type: "country",
    continent: "Africa",
    coordinates: [10.2679, 1.6508],
    flag: "🇬🇶",
    officeType: "regional",
    population: "1.5 million",
    status: "planned"
  },
  {
    id: "154",
    name: "Eritrea",
    type: "country",
    continent: "Africa",
    coordinates: [39.7823, 15.1794],
    flag: "🇪🇷",
    officeType: "regional",
    population: "3.6 million",
    status: "planned"
  },
  {
    id: "155",
    name: "Estonia",
    type: "country",
    continent: "Europe",
    coordinates: [25.0136, 58.5953],
    flag: "🇪🇪",
    officeType: "regional",
    population: "1.3 million",
    status: "planned"
  },
  {
    id: "156",
    name: "Eswatini",
    type: "country",
    continent: "Africa",
    coordinates: [31.4659, -26.5225],
    flag: "🇸🇿",
    officeType: "regional",
    population: "1.2 million",
    status: "planned"
  },
  {
    id: "157",
    name: "Ethiopia",
    type: "country",
    continent: "Africa",
    coordinates: [40.4897, 9.1450],
    flag: "🇪🇹",
    officeType: "regional",
    population: "117.9 million",
    status: "planned"
  },
  {
    id: "158",
    name: "FR Auvergne-Rhône-Alpes",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [4.6034, 45.3601],
    flag: "🇫🇷",
    officeType: "region",
    population: "8.0 million",
    capital: "Lyon",
    status: "planned"
  },
  {
    id: "159",
    name: "FR Bourgogne-Franche-Comté",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [4.8656, 47.2808],
    flag: "🇫🇷",
    officeType: "region",
    population: "2.8 million",
    capital: "Dijon",
    status: "planned"
  },
  {
    id: "160",
    name: "FR Bretagne",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [-3.0000, 48.0000],
    flag: "🇫🇷",
    officeType: "region",
    population: "3.3 million",
    capital: "Rennes",
    status: "planned"
  },
  {
    id: "161",
    name: "FR Centre-Val de Loire",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [1.7500, 47.7516],
    flag: "🇫🇷",
    officeType: "region",
    population: "2.6 million",
    capital: "Orléans",
    status: "planned"
  },
  {
    id: "162",
    name: "FR Corse",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [9.0000, 42.0396],
    flag: "🇫🇷",
    officeType: "territorial_collectivity",
    population: "339,000",
    capital: "Ajaccio",
    status: "planned"
  },
  {
    id: "163",
    name: "FR Grand Est",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [6.1879, 48.7000],
    flag: "🇫🇷",
    officeType: "region",
    population: "5.5 million",
    capital: "Strasbourg",
    status: "planned"
  },
  {
    id: "164",
    name: "FR Guadeloupe",
    type: "territory",
    country: "France",
    continent: "North America",
    coordinates: [-61.5804, 16.2650],
    flag: "🇬🇵",
    officeType: "overseas_region",
    population: "400,000",
    capital: "Basse-Terre",
    status: "planned"
  },
  {
    id: "165",
    name: "FR Guyana",
    type: "territory",
    country: "France",
    continent: "South America",
    coordinates: [-53.1258, 3.9339],
    flag: "🇬🇫",
    officeType: "overseas_region",
    population: "290,000",
    capital: "Cayenne",
    status: "planned"
  },
  {
    id: "166",
    name: "FR Hauts-de-France",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [2.9540, 50.4801],
    flag: "🇫🇷",
    officeType: "region",
    population: "6.0 million",
    capital: "Lille",
    status: "planned"
  },
  {
    id: "167",
    name: "FR Martinique",
    type: "territory",
    country: "France",
    continent: "North America",
    coordinates: [-61.0242, 14.6415],
    flag: "🇲🇶",
    officeType: "overseas_region",
    population: "375,000",
    capital: "Fort-de-France",
    status: "planned"
  },
  {
    id: "168",
    name: "FR Mayotte",
    type: "territory",
    country: "France",
    continent: "Africa",
    coordinates: [45.1662, -12.8275],
    flag: "🇾🇹",
    officeType: "overseas_department",
    population: "279,000",
    capital: "Mamoudzou",
    status: "planned"
  },
  {
    id: "169",
    name: "FR Normandie",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [-0.3700, 49.1829],
    flag: "🇫🇷",
    officeType: "region",
    population: "3.3 million",
    capital: "Rouen",
    status: "planned"
  },
  {
    id: "170",
    name: "FR Nouvelle-Aquitaine",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [-0.5800, 45.8336],
    flag: "🇫🇷",
    officeType: "region",
    population: "6.0 million",
    capital: "Bordeaux",
    status: "planned"
  },
  {
    id: "171",
    name: "FR Occitanie",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [2.6050, 43.9493],
    flag: "🇫🇷",
    officeType: "region",
    population: "5.9 million",
    capital: "Toulouse",
    status: "planned"
  },
  {
    id: "172",
    name: "FR Pays de la Loire",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [-1.5534, 47.4034],
    flag: "🇫🇷",
    officeType: "region",
    population: "3.8 million",
    capital: "Nantes",
    status: "planned"
  },
  {
    id: "173",
    name: "FR Provence-Alpes-Côte d'Azur",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [6.1296, 43.9352],
    flag: "🇫🇷",
    officeType: "region",
    population: "5.1 million",
    capital: "Marseille",
    status: "planned"
  },
  {
    id: "174",
    name: "FR Réunion",
    type: "territory",
    country: "France",
    continent: "Africa",
    coordinates: [55.5364, -21.1151],
    flag: "🇷🇪",
    officeType: "overseas_region",
    population: "895,000",
    capital: "Saint-Denis",
    status: "planned"
  },
  {
    id: "175",
    name: "FR Île-de-France",
    type: "region",
    country: "France",
    continent: "Europe",
    coordinates: [2.2137, 48.8566],
    flag: "🇫🇷",
    officeType: "region",
    population: "12.3 million",
    capital: "Paris",
    status: "planned"
  },
  {
    id: "176",
    name: "Falkland Islands",
    type: "territory",
    country: "United Kingdom",
    continent: "South America",
    coordinates: [-59.5236, -51.7963],
    flag: "🇫🇰",
    officeType: "territorial",
    population: "3,200",
    status: "planned"
  },
  {
    id: "177",
    name: "Faroe Islands",
    type: "territory",
    country: "Denmark",
    continent: "Europe",
    coordinates: [-6.9118, 61.8926],
    flag: "🇫🇴",
    officeType: "territorial",
    population: "53,000",
    status: "planned"
  },
  {
    id: "178",
    name: "Fiji",
    type: "country",
    continent: "Oceania",
    coordinates: [179.4144, -16.5790],
    flag: "🇫🇯",
    officeType: "regional",
    population: "896,000",
    status: "planned"
  },
  {
    id: "179",
    name: "Finland",
    type: "country",
    continent: "Europe",
    coordinates: [25.7482, 61.9241],
    flag: "🇫🇮",
    officeType: "regional",
    population: "5.5 million",
    status: "planned"
  },
  {
    id: "180",
    name: "France",
    type: "country",
    continent: "Europe",
    coordinates: [2.2137, 46.2276],
    flag: "🇫🇷",
    officeType: "regional",
    population: "67.7 million",
    status: "planned"
  },
  {
    id: "181",
    name: "French Polynesia",
    type: "territory",
    country: "France",
    continent: "Oceania",
    coordinates: [-149.4068, -17.6797],
    flag: "🇵🇫",
    officeType: "territorial",
    population: "281,000",
    status: "planned"
  },
  {
    id: "182",
    name: "GB East England",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [0.4700, 52.2400],
    flag: "🇬🇧",
    officeType: "region",
    population: "6.2 million",
    status: "planned"
  },
  {
    id: "183",
    name: "GB East Midlands",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-1.0000, 52.8000],
    flag: "🇬🇧",
    officeType: "region",
    population: "4.8 million",
    status: "planned"
  },
  {
    id: "184",
    name: "GB London",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-0.1276, 51.5074],
    flag: "🇬🇧",
    officeType: "region",
    population: "9.0 million",
    status: "active"
  },
  {
    id: "185",
    name: "GB North East England",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-1.6000, 54.9000],
    flag: "🇬🇧",
    officeType: "region",
    population: "2.6 million",
    status: "planned"
  },
  {
    id: "186",
    name: "GB North West England",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-2.5000, 54.0000],
    flag: "🇬🇧",
    officeType: "region",
    population: "7.3 million",
    status: "planned"
  },
  {
    id: "187",
    name: "GB Northern Ireland",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-6.7320, 54.7877],
    flag: "🇬🇧",
    officeType: "region",
    population: "1.9 million",
    status: "planned"
  },
  {
    id: "188",
    name: "GB Scotland",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-4.2026, 56.4907],
    flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    officeType: "region",
    population: "5.5 million",
    status: "active"
  },
  {
    id: "189",
    name: "GB South East England",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-0.5000, 51.2000],
    flag: "🇬🇧",
    officeType: "region",
    population: "9.2 million",
    status: "planned"
  },
  {
    id: "190",
    name: "GB South West England",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-3.5000, 50.8000],
    flag: "🇬🇧",
    officeType: "region",
    population: "5.6 million",
    status: "planned"
  },
  {
    id: "191",
    name: "GB Wales",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-3.7837, 52.1307],
    flag: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    officeType: "region",
    population: "3.1 million",
    status: "planned"
  },
  {
    id: "192",
    name: "GB West Midlands",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-2.0000, 52.5000],
    flag: "🇬🇧",
    officeType: "region",
    population: "5.9 million",
    status: "planned"
  },
  {
    id: "193",
    name: "GB Yorkshire and the Humber",
    type: "region",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-1.5000, 53.8000],
    flag: "🇬🇧",
    officeType: "region",
    population: "5.5 million",
    status: "planned"
  },
  {
    id: "194",
    name: "Gabon",
    type: "country",
    continent: "Africa",
    coordinates: [11.6094, -0.8037],
    flag: "🇬🇦",
    officeType: "regional",
    population: "2.3 million",
    status: "planned"
  },
  {
    id: "195",
    name: "Georgia",
    type: "country",
    continent: "Asia",
    coordinates: [43.3569, 42.3154],
    flag: "🇬🇪",
    officeType: "regional",
    population: "3.7 million",
    status: "planned"
  },
  {
    id: "196",
    name: "Germany",
    type: "country",
    continent: "Europe",
    coordinates: [10.4515, 51.1657],
    flag: "🇩🇪",
    officeType: "regional",
    population: "83.2 million",
    status: "planned"
  },
  {
    id: "197",
    name: "Ghana",
    type: "country",
    continent: "Africa",
    coordinates: [-1.0232, 7.9465],
    flag: "🇬🇭",
    officeType: "regional",
    population: "32.8 million",
    status: "planned"
  },
  {
    id: "198",
    name: "Gibraltar",
    type: "territory",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-5.3536, 36.1408],
    flag: "🇬🇮",
    officeType: "territorial",
    population: "34,000",
    status: "planned"
  },
  {
    id: "199",
    name: "Greece",
    type: "country",
    continent: "Europe",
    coordinates: [21.8243, 39.0742],
    flag: "🇬🇷",
    officeType: "regional",
    population: "10.4 million",
    status: "planned"
  },
  {
    id: "200",
    name: "Grenada",
    type: "country",
    continent: "North America",
    coordinates: [-61.6790, 12.1165],
    flag: "🇬🇩",
    officeType: "regional",
    population: "113,000",
    status: "planned"
  },
  {
    id: "201",
    name: "Guam",
    type: "territory",
    country: "United States",
    continent: "Oceania",
    coordinates: [144.7937, 13.4443],
    flag: "🇬🇺",
    officeType: "territorial",
    population: "171,000",
    status: "planned"
  },
  {
    id: "202",
    name: "Guatemala",
    type: "country",
    continent: "North America",
    coordinates: [-90.2308, 15.7835],
    flag: "🇬🇹",
    officeType: "regional",
    population: "17.6 million",
    status: "planned"
  },
  {
    id: "203",
    name: "Guernsey",
    type: "territory",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-2.5358, 49.4484],
    flag: "🇬🇬",
    officeType: "territorial",
    population: "63,000",
    status: "planned"
  },
  {
    id: "204",
    name: "Guinea",
    type: "country",
    continent: "Africa",
    coordinates: [-9.6966, 9.9456],
    flag: "🇬🇳",
    officeType: "regional",
    population: "13.5 million",
    status: "planned"
  },
  {
    id: "205",
    name: "Guinea-Bissau",
    type: "country",
    continent: "Africa",
    coordinates: [-15.1804, 11.8037],
    flag: "🇬🇼",
    officeType: "regional",
    population: "2.0 million",
    status: "planned"
  },
  {
    id: "206",
    name: "Guyana",
    type: "country",
    continent: "South America",
    coordinates: [-58.9302, 4.8604],
    flag: "🇬🇾",
    officeType: "regional",
    population: "0.8 million",
    status: "planned"
  },
  {
    id: "207",
    name: "Haiti",
    type: "country",
    continent: "North America",
    coordinates: [-72.2852, 18.9712],
    flag: "🇭🇹",
    officeType: "regional",
    population: "11.4 million",
    status: "planned"
  },
  {
    id: "208",
    name: "Honduras",
    type: "country",
    continent: "North America",
    coordinates: [-86.2419, 15.1999],
    flag: "🇭🇳",
    officeType: "regional",
    population: "10.1 million",
    status: "planned"
  },
  {
    id: "209",
    name: "Hong Kong SAR",
    type: "territory",
    country: "China",
    continent: "Asia",
    coordinates: [114.1694, 22.3193],
    flag: "🇭🇰",
    officeType: "territory",
    population: "7.5 million",
    status: "planned"
  },
  {
    id: "210",
    name: "Hungary",
    type: "country",
    continent: "Europe",
    coordinates: [19.5033, 47.1625],
    flag: "🇭🇺",
    officeType: "regional",
    population: "9.7 million",
    status: "planned"
  },
  {
    id: "211",
    name: "ID Java Island",
    type: "island",
    country: "Indonesia",
    continent: "Asia",
    coordinates: [110.0000, -7.5000],
    flag: "🇮🇩",
    officeType: "island_region",
    population: "145 million",
    status: "planned"
  },
  {
    id: "212",
    name: "ID Kalimantan",
    type: "island",
    country: "Indonesia",
    continent: "Asia",
    coordinates: [114.0000, 0.0000],
    flag: "🇮🇩",
    officeType: "island_region",
    population: "16 million",
    status: "planned"
  },
  {
    id: "213",
    name: "ID Lesser Sunda Islands",
    type: "island",
    country: "Indonesia",
    continent: "Asia",
    coordinates: [119.0000, -8.5000],
    flag: "🇮🇩",
    officeType: "island_region",
    population: "15 million",
    status: "planned"
  },
  {
    id: "214",
    name: "ID Maluku Islands",
    type: "island",
    country: "Indonesia",
    continent: "Asia",
    coordinates: [129.0000, -3.0000],
    flag: "🇮🇩",
    officeType: "island_region",
    population: "1.8 million",
    status: "planned"
  },
  {
    id: "215",
    name: "ID Sulawesi Island",
    type: "island",
    country: "Indonesia",
    continent: "Asia",
    coordinates: [121.0000, -2.0000],
    flag: "🇮🇩",
    officeType: "island_region",
    population: "19 million",
    status: "planned"
  },
  {
    id: "216",
    name: "ID Sumatra Island",
    type: "island",
    country: "Indonesia",
    continent: "Asia",
    coordinates: [101.0000, 0.0000],
    flag: "🇮🇩",
    officeType: "island_region",
    population: "58 million",
    status: "planned"
  },
  {
    id: "217",
    name: "ID Western New Guinea",
    type: "island",
    country: "Indonesia",
    continent: "Asia",
    coordinates: [138.0000, -4.0000],
    flag: "🇮🇩",
    officeType: "island_region",
    population: "4.3 million",
    status: "planned"
  },
  {
    id: "218",
    name: "Iceland",
    type: "country",
    continent: "Europe",
    coordinates: [-19.0208, 64.9631],
    flag: "🇮🇸",
    officeType: "regional",
    population: "0.4 million",
    status: "planned"
  },
  {
    id: "219",
    name: "IN Central India",
    type: "region",
    country: "India",
    continent: "Asia",
    coordinates: [78.6569, 22.9734],
    flag: "🇮🇳",
    officeType: "region",
    population: "125 million",
    status: "planned"
  },
  {
    id: "220",
    name: "IN Eastern India",
    type: "region",
    country: "India",
    continent: "Asia",
    coordinates: [87.8550, 23.6850],
    flag: "🇮🇳",
    officeType: "region",
    population: "304 million",
    status: "planned"
  },
  {
    id: "221",
    name: "IN North-Eastern India",
    type: "region",
    country: "India",
    continent: "Asia",
    coordinates: [93.9063, 26.2006],
    flag: "🇮🇳",
    officeType: "region",
    population: "45 million",
    status: "planned"
  },
  {
    id: "222",
    name: "IN Northern India",
    type: "region",
    country: "India",
    continent: "Asia",
    coordinates: [77.1025, 28.7041],
    flag: "🇮🇳",
    officeType: "region",
    population: "525 million",
    status: "planned"
  },
  {
    id: "223",
    name: "IN Southern India",
    type: "region",
    country: "India",
    continent: "Asia",
    coordinates: [78.6569, 15.2993],
    flag: "🇮🇳",
    officeType: "region",
    population: "253 million",
    status: "planned"
  },
  {
    id: "224",
    name: "IN Western India",
    type: "region",
    country: "India",
    continent: "Asia",
    coordinates: [72.8777, 19.0760],
    flag: "🇮🇳",
    officeType: "region",
    population: "188 million",
    status: "planned"
  },
  {
    id: "225",
    name: "India",
    type: "country",
    continent: "Asia",
    coordinates: [78.9629, 20.5937],
    flag: "🇮🇳",
    officeType: "regional",
    population: "1.4 billion",
    status: "planned"
  },
  {
    id: "226",
    name: "Iran",
    type: "country",
    continent: "Asia",
    coordinates: [53.6880, 32.4279],
    flag: "🇮🇷",
    officeType: "regional",
    population: "85.0 million",
    status: "planned"
  },
  {
    id: "227",
    name: "Iraq",
    type: "country",
    continent: "Asia",
    coordinates: [43.6793, 33.2232],
    flag: "🇮🇶",
    officeType: "regional",
    population: "41.2 million",
    status: "planned"
  },
  {
    id: "228",
    name: "Ireland",
    type: "country",
    continent: "Europe",
    coordinates: [-8.2439, 53.4129],
    flag: "🇮🇪",
    officeType: "regional",
    population: "5.0 million",
    status: "active"
  },
  {
    id: "229",
    name: "Isle of Man",
    type: "territory",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-4.4827, 54.2361],
    flag: "🇮🇲",
    officeType: "territorial",
    population: "85,000",
    status: "planned"
  },
  {
    id: "230",
    name: "Israel",
    type: "country",
    continent: "Asia",
    coordinates: [34.8516, 31.0461],
    flag: "🇮🇱",
    officeType: "regional",
    population: "9.3 million",
    status: "planned"
  },
  {
    id: "231",
    name: "IT Abruzzo",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [13.9994, 42.0951],
    flag: "🇮🇹",
    officeType: "region",
    population: "1.3 million",
    capital: "L'Aquila",
    status: "planned"
  },
  {
    id: "232",
    name: "IT Aosta Valley",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [7.3554, 45.7383],
    flag: "🇮🇹",
    officeType: "region",
    population: "125,000",
    capital: "Aosta",
    status: "planned"
  },
  {
    id: "233",
    name: "IT Apulia",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [16.5000, 41.0000],
    flag: "🇮🇹",
    officeType: "region",
    population: "4.0 million",
    capital: "Bari",
    status: "planned"
  },
  {
    id: "234",
    name: "IT Basilicata",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [15.8050, 40.5706],
    flag: "🇮🇹",
    officeType: "region",
    population: "563,000",
    capital: "Potenza",
    status: "planned"
  },
  {
    id: "235",
    name: "IT Calabria",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [16.2500, 39.0000],
    flag: "🇮🇹",
    officeType: "region",
    population: "1.9 million",
    capital: "Catanzaro",
    status: "planned"
  },
  {
    id: "236",
    name: "IT Campania",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [14.7500, 40.8333],
    flag: "🇮🇹",
    officeType: "region",
    population: "5.8 million",
    capital: "Naples",
    status: "planned"
  },
  {
    id: "237",
    name: "IT Emilia-Romagna",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [11.3426, 44.4949],
    flag: "🇮🇹",
    officeType: "region",
    population: "4.5 million",
    capital: "Bologna",
    status: "planned"
  },
  {
    id: "238",
    name: "IT Friuli-Venezia Giulia",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [13.0000, 46.0000],
    flag: "🇮🇹",
    officeType: "region",
    population: "1.2 million",
    capital: "Trieste",
    status: "planned"
  },
  {
    id: "239",
    name: "IT Lazio",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [12.5736, 41.8719],
    flag: "🇮🇹",
    officeType: "region",
    population: "5.9 million",
    capital: "Rome",
    status: "planned"
  },
  {
    id: "240",
    name: "IT Liguria",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [8.9463, 44.4056],
    flag: "🇮🇹",
    officeType: "region",
    population: "1.5 million",
    capital: "Genoa",
    status: "planned"
  },
  {
    id: "241",
    name: "IT Lombardy",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [9.4229, 45.4654],
    flag: "🇮🇹",
    officeType: "region",
    population: "10.1 million",
    capital: "Milan",
    status: "planned"
  },
  {
    id: "242",
    name: "IT Marche",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [13.5186, 43.6158],
    flag: "🇮🇹",
    officeType: "region",
    population: "1.5 million",
    capital: "Ancona",
    status: "planned"
  },
  {
    id: "243",
    name: "IT Molise",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [14.6687, 41.5810],
    flag: "🇮🇹",
    officeType: "region",
    population: "305,000",
    capital: "Campobasso",
    status: "planned"
  },
  {
    id: "244",
    name: "IT Piedmont",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [7.6868, 45.0703],
    flag: "🇮🇹",
    officeType: "region",
    population: "4.4 million",
    capital: "Turin",
    status: "planned"
  },
  {
    id: "245",
    name: "IT Sardinia",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [9.1216, 40.1209],
    flag: "🇮🇹",
    officeType: "region",
    population: "1.6 million",
    capital: "Cagliari",
    status: "planned"
  },
  {
    id: "246",
    name: "IT Sicily",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [14.0154, 37.5999],
    flag: "🇮🇹",
    officeType: "region",
    population: "5.0 million",
    capital: "Palermo",
    status: "planned"
  },
  {
    id: "247",
    name: "IT South Tyrol",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [11.3547, 46.4983],
    flag: "🇮🇹",
    officeType: "autonomous_province",
    population: "532,000",
    capital: "Bolzano",
    status: "planned"
  },
  {
    id: "248",
    name: "IT Trentino",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [11.1217, 46.0679],
    flag: "🇮🇹",
    officeType: "autonomous_province",
    population: "541,000",
    capital: "Trento",
    status: "planned"
  },
  {
    id: "249",
    name: "IT Tuscany",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [11.2558, 43.7711],
    flag: "🇮🇹",
    officeType: "region",
    population: "3.7 million",
    capital: "Florence",
    status: "planned"
  },
  {
    id: "250",
    name: "IT Umbria",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [12.5736, 43.1122],
    flag: "🇮🇹",
    officeType: "region",
    population: "882,000",
    capital: "Perugia",
    status: "planned"
  },
  {
    id: "251",
    name: "IT Veneto",
    type: "region",
    country: "Italy",
    continent: "Europe",
    coordinates: [12.2388, 45.4408],
    flag: "🇮🇹",
    officeType: "region",
    population: "4.9 million",
    capital: "Venice",
    status: "planned"
  },
  {
    id: "252",
    name: "Jamaica",
    type: "country",
    continent: "North America",
    coordinates: [-77.2975, 18.1096],
    flag: "🇯🇲",
    officeType: "regional",
    population: "2.9 million",
    status: "planned"
  },
  {
    id: "253",
    name: "JP Chūbu",
    type: "region",
    country: "Japan",
    continent: "Asia",
    coordinates: [137.9691, 36.2048],
    flag: "🇯🇵",
    officeType: "region",
    population: "21.7 million",
    status: "planned"
  },
  {
    id: "254",
    name: "JP Chūgoku",
    type: "region",
    country: "Japan",
    continent: "Asia",
    coordinates: [133.0000, 34.7000],
    flag: "🇯🇵",
    officeType: "region",
    population: "7.3 million",
    status: "planned"
  },
  {
    id: "255",
    name: "JP Hokkaidō",
    type: "region",
    country: "Japan",
    continent: "Asia",
    coordinates: [142.3917, 43.2642],
    flag: "🇯🇵",
    officeType: "region",
    population: "5.2 million",
    status: "planned"
  },
  {
    id: "256",
    name: "JP Kansai",
    type: "region",
    country: "Japan",
    continent: "Asia",
    coordinates: [135.7556, 34.6851],
    flag: "🇯🇵",
    officeType: "region",
    population: "22.7 million",
    status: "planned"
  },
  {
    id: "257",
    name: "JP Kantō",
    type: "region",
    country: "Japan",
    continent: "Asia",
    coordinates: [139.6917, 35.6895],
    flag: "🇯🇵",
    officeType: "region",
    population: "43.3 million",
    status: "planned"
  },
  {
    id: "258",
    name: "JP Kyūshū & Okinawa",
    type: "region",
    country: "Japan",
    continent: "Asia",
    coordinates: [130.4017, 31.9077],
    flag: "🇜🇵",
    officeType: "region",
    population: "14.3 million",
    status: "planned"
  },
  {
    id: "259",
    name: "JP Shikoku",
    type: "region",
    country: "Japan",
    continent: "Asia",
    coordinates: [133.5000, 33.7500],
    flag: "🇯🇵",
    officeType: "region",
    population: "3.8 million",
    status: "planned"
  },
  {
    id: "260",
    name: "JP Tōhoku",
    type: "region",
    country: "Japan",
    continent: "Asia",
    coordinates: [140.9356, 38.7167],
    flag: "🇯🇵",
    officeType: "region",
    population: "8.8 million",
    status: "planned"
  },
  {
    id: "261",
    name: "Japan",
    type: "country",
    continent: "Asia",
    coordinates: [138.2529, 36.2048],
    flag: "🇯🇵",
    officeType: "regional",
    population: "125 million",
    status: "planned"
  },
  {
    id: "262",
    name: "Jersey",
    type: "territory",
    country: "United Kingdom",
    continent: "Europe",
    coordinates: [-2.1358, 49.2144],
    flag: "🇯🇪",
    officeType: "territorial",
    population: "108,000",
    status: "planned"
  },
  {
    id: "263",
    name: "Jordan",
    type: "country",
    continent: "Asia",
    coordinates: [36.2384, 30.5852],
    flag: "🇯🇴",
    officeType: "regional",
    population: "10.3 million",
    status: "planned"
  },
  {
    id: "264",
    name: "KR Busan",
    type: "metropolitan_city",
    country: "South Korea",
    continent: "Asia",
    coordinates: [129.0756, 35.1796],
    flag: "🇰🇷",
    officeType: "metropolitan_city",
    population: "3.4 million",
    status: "planned"
  },
  {
    id: "265",
    name: "KR Daegu",
    type: "metropolitan_city",
    country: "South Korea",
    continent: "Asia",
    coordinates: [128.6014, 35.8714],
    flag: "🇰🇷",
    officeType: "metropolitan_city",
    population: "2.4 million",
    status: "planned"
  },
  {
    id: "266",
    name: "KR Daejeon",
    type: "metropolitan_city",
    country: "South Korea",
    continent: "Asia",
    coordinates: [127.3845, 36.3504],
    flag: "🇰🇷",
    officeType: "metropolitan_city",
    population: "1.5 million",
    status: "planned"
  },
  {
    id: "267",
    name: "KR Gangwon",
    type: "province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [128.2132, 37.8228],
    flag: "🇰🇷",
    officeType: "province",
    population: "1.5 million",
    capital: "Chuncheon",
    status: "planned"
  },
  {
    id: "268",
    name: "KR Gwangju",
    type: "metropolitan_city",
    country: "South Korea",
    continent: "Asia",
    coordinates: [126.8526, 35.1595],
    flag: "🇰🇷",
    officeType: "metropolitan_city",
    population: "1.5 million",
    status: "planned"
  },
  {
    id: "269",
    name: "KR Gyeonggi",
    type: "province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [127.5183, 37.4138],
    flag: "🇰🇷",
    officeType: "province",
    population: "13.2 million",
    capital: "Suwon",
    status: "planned"
  },
  {
    id: "270",
    name: "KR Incheon",
    type: "metropolitan_city",
    country: "South Korea",
    continent: "Asia",
    coordinates: [126.7052, 37.4563],
    flag: "🇰🇷",
    officeType: "metropolitan_city",
    population: "2.9 million",
    status: "planned"
  },
  {
    id: "271",
    name: "KR Jeju",
    type: "special_province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [126.5312, 33.4996],
    flag: "🇰🇷",
    officeType: "special_province",
    population: "672,000",
    status: "planned"
  },
  {
    id: "272",
    name: "KR North Chungcheong",
    type: "province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [127.7303, 36.8000],
    flag: "🇰🇷",
    officeType: "province",
    population: "1.6 million",
    capital: "Cheongju",
    status: "planned"
  },
  {
    id: "273",
    name: "KR North Gyeongsang",
    type: "province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [128.8889, 36.4919],
    flag: "🇰🇷",
    officeType: "province",
    population: "2.7 million",
    capital: "Andong",
    status: "planned"
  },
  {
    id: "274",
    name: "KR North Jeolla",
    type: "province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [127.6890, 35.7175],
    flag: "🇰🇷",
    officeType: "province",
    population: "1.8 million",
    capital: "Jeonju",
    status: "planned"
  },
  {
    id: "275",
    name: "KR Sejong",
    type: "special_city",
    country: "South Korea",
    continent: "Asia",
    coordinates: [127.2890, 36.4800],
    flag: "🇰🇷",
    officeType: "special_city",
    population: "365,000",
    status: "planned"
  },
  {
    id: "276",
    name: "KR Seoul",
    type: "special_city",
    country: "South Korea",
    continent: "Asia",
    coordinates: [126.9780, 37.5665],
    flag: "🇰🇷",
    officeType: "special_city",
    population: "9.7 million",
    status: "planned"
  },
  {
    id: "277",
    name: "KR South Chungcheong",
    type: "province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [126.8000, 36.5184],
    flag: "🇰🇷",
    officeType: "province",
    population: "2.1 million",
    capital: "Hongseong",
    status: "planned"
  },
  {
    id: "278",
    name: "KR South Gyeongsang",
    type: "province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [128.2132, 35.4606],
    flag: "🇰🇷",
    officeType: "province",
    population: "3.3 million",
    capital: "Changwon",
    status: "planned"
  },
  {
    id: "279",
    name: "KR South Jeolla",
    type: "province",
    country: "South Korea",
    continent: "Asia",
    coordinates: [126.9910, 34.8679],
    flag: "🇰🇷",
    officeType: "province",
    population: "1.8 million",
    capital: "Muan",
    status: "planned"
  },
  {
    id: "280",
    name: "KR Ulsan",
    type: "metropolitan_city",
    country: "South Korea",
    continent: "Asia",
    coordinates: [129.3114, 35.5384],
    flag: "🇰🇷",
    officeType: "metropolitan_city",
    population: "1.1 million",
    status: "planned"
  },
  {
    id: "281",
    name: "Kazakhstan",
    type: "country",
    continent: "Asia",
    coordinates: [66.9237, 48.0196],
    flag: "🇰🇿",
    officeType: "regional",
    population: "19.0 million",
    status: "planned"
  },
  {
    id: "282",
    name: "Kenya",
    type: "country",
    continent: "Africa",
    coordinates: [37.9062, -0.0236],
    flag: "🇰🇪",
    officeType: "regional",
    population: "54.9 million",
    status: "planned"
  },
  {
    id: "283",
    name: "Kiribati",
    type: "country",
    continent: "Oceania",
    coordinates: [-157.3768, 1.8709],
    flag: "🇰🇮",
    officeType: "regional",
    population: "0.1 million",
    status: "planned"
  },
  {
    id: "284",
    name: "Kosovo",
    type: "country",
    continent: "Europe",
    coordinates: [20.9020, 42.6026],
    flag: "🇽🇰",
    officeType: "regional",
    population: "1.8 million",
    status: "planned"
  },
  {
    id: "285",
    name: "Kuwait",
    type: "country",
    continent: "Asia",
    coordinates: [47.4818, 29.3117],
    flag: "🇰🇼",
    officeType: "regional",
    population: "4.3 million",
    status: "planned"
  },
  {
    id: "286",
    name: "Kyrgyz Republic",
    type: "country",
    continent: "Asia",
    coordinates: [74.7661, 41.2044],
    flag: "🇰🇬",
    officeType: "regional",
    population: "6.7 million",
    status: "planned"
  },
  {
    id: "287",
    name: "Lao PDR",
    type: "country",
    continent: "Asia",
    coordinates: [102.4955, 19.8563],
    flag: "🇱🇦",
    officeType: "regional",
    population: "7.4 million",
    status: "planned"
  },
  {
    id: "288",
    name: "Latvia",
    type: "country",
    continent: "Europe",
    coordinates: [24.6032, 56.8796],
    flag: "🇱🇻",
    officeType: "regional",
    population: "1.9 million",
    status: "planned"
  },
  {
    id: "289",
    name: "Lebanon",
    type: "country",
    continent: "Asia",
    coordinates: [35.8623, 33.8547],
    flag: "🇱🇧",
    officeType: "regional",
    population: "6.8 million",
    status: "planned"
  },
  {
    id: "290",
    name: "Lesotho",
    type: "country",
    continent: "Africa",
    coordinates: [28.2336, -29.6100],
    flag: "🇱🇸",
    officeType: "regional",
    population: "2.2 million",
    status: "planned"
  },
  {
    id: "291",
    name: "Liberia",
    type: "country",
    continent: "Africa",
    coordinates: [-9.4295, 6.4281],
    flag: "🇱🇷",
    officeType: "regional",
    population: "5.2 million",
    status: "planned"
  },
  {
    id: "292",
    name: "Libya",
    type: "country",
    continent: "Africa",
    coordinates: [17.2283, 26.3351],
    flag: "🇱🇾",
    officeType: "regional",
    population: "6.9 million",
    status: "planned"
  },
  {
    id: "293",
    name: "Liechtenstein",
    type: "country",
    continent: "Europe",
    coordinates: [9.5554, 47.1660],
    flag: "🇱🇮",
    officeType: "regional",
    population: "39,000",
    status: "planned"
  },
  {
    id: "294",
    name: "Lithuania",
    type: "country",
    continent: "Europe",
    coordinates: [23.8813, 55.1694],
    flag: "🇱🇹",
    officeType: "regional",
    population: "2.8 million",
    status: "planned"
  },
  {
    id: "295",
    name: "Luxembourg",
    type: "country",
    continent: "Europe",
    coordinates: [6.1296, 49.8153],
    flag: "🇱🇺",
    officeType: "regional",
    population: "0.6 million",
    status: "planned"
  },
  {
    id: "296",
    name: "Macao SAR",
    type: "territory",
    country: "China",
    continent: "Asia",
    coordinates: [113.5439, 22.1987],
    flag: "🇲🇴",
    officeType: "territory",
    population: "0.7 million",
    status: "planned"
  },
  {
    id: "297",
    name: "Madagascar",
    type: "country",
    continent: "Africa",
    coordinates: [46.8691, -18.8792],
    flag: "🇲🇬",
    officeType: "regional",
    population: "28.9 million",
    status: "planned"
  },
  {
    id: "298",
    name: "Madeira",
    type: "region",
    country: "Portugal",
    continent: "Europe",
    coordinates: [-16.9595, 32.7607],
    flag: "🇵🇹",
    officeType: "autonomous_region",
    population: "254,000",
    status: "planned"
  },
  {
    id: "299",
    name: "Malawi",
    type: "country",
    continent: "Africa",
    coordinates: [34.3015, -13.2543],
    flag: "🇲🇼",
    officeType: "regional",
    population: "19.6 million",
    status: "planned"
  },
  {
    id: "300",
    name: "Malaysia",
    type: "country",
    continent: "Asia",
    coordinates: [101.9758, 4.2105],
    flag: "🇲🇾",
    officeType: "regional",
    population: "33.8 million",
    status: "planned"
  },
  {
    id: "301",
    name: "Maldives",
    type: "country",
    continent: "Asia",
    coordinates: [73.2207, 3.2028],
    flag: "🇲🇻",
    officeType: "regional",
    population: "0.5 million",
    status: "planned"
  },
  {
    id: "302",
    name: "Mali",
    type: "country",
    continent: "Africa",
    coordinates: [-3.9962, 17.5707],
    flag: "🇲🇱",
    officeType: "regional",
    population: "21.9 million",
    status: "planned"
  },
  {
    id: "303",
    name: "Malta",
    type: "country",
    continent: "Europe",
    coordinates: [14.3754, 35.9375],
    flag: "🇲🇹",
    officeType: "regional",
    population: "0.5 million",
    status: "planned"
  },
  {
    id: "304",
    name: "Marshall Islands",
    type: "country",
    continent: "Oceania",
    coordinates: [171.1845, 7.1315],
    flag: "🇲🇭",
    officeType: "regional",
    population: "59,000",
    status: "planned"
  },
  {
    id: "305",
    name: "Mauritania",
    type: "country",
    continent: "Africa",
    coordinates: [-10.9408, 21.0079],
    flag: "🇲🇷",
    officeType: "regional",
    population: "4.8 million",
    status: "planned"
  },
  {
    id: "306",
    name: "Mauritius",
    type: "country",
    continent: "Africa",
    coordinates: [57.5522, -20.3484],
    flag: "🇲🇺",
    officeType: "regional",
    population: "1.3 million",
    status: "planned"
  },
  {
    id: "307",
    name: "Mexico",
    type: "country",
    continent: "North America",
    coordinates: [-102.5528, 23.6345],
    flag: "🇲🇽",
    officeType: "regional",
    population: "130.3 million",
    status: "planned"
  },
  {
    id: "308",
    name: "Micronesia",
    type: "country",
    continent: "Oceania",
    coordinates: [158.2151, 6.8840],
    flag: "🇫🇲",
    officeType: "regional",
    population: "0.1 million",
    status: "planned"
  },
  {
    id: "309",
    name: "Moldova",
    type: "country",
    continent: "Europe",
    coordinates: [28.3699, 47.4116],
    flag: "🇲🇩",
    officeType: "regional",
    population: "2.6 million",
    status: "planned"
  },
  {
    id: "310",
    name: "Monaco",
    type: "country",
    continent: "Europe",
    coordinates: [7.4246, 43.7384],
    flag: "🇲🇨",
    officeType: "regional",
    population: "39,000",
    status: "planned"
  },
  {
    id: "311",
    name: "Mongolia",
    type: "country",
    continent: "Asia",
    coordinates: [103.8467, 46.8625],
    flag: "🇲🇳",
    officeType: "regional",
    population: "3.4 million",
    status: "planned"
  },
  {
    id: "312",
    name: "Montenegro",
    type: "country",
    continent: "Europe",
    coordinates: [19.3744, 42.7087],
    flag: "🇲🇪",
    officeType: "regional",
    population: "0.6 million",
    status: "planned"
  },
  {
    id: "313",
    name: "Montserrat",
    type: "territory",
    country: "United Kingdom",
    continent: "North America",
    coordinates: [-62.1874, 16.7425],
    flag: "🇲🇸",
    officeType: "territorial",
    population: "5,000",
    status: "planned"
  },
  {
    id: "314",
    name: "Morocco",
    type: "country",
    continent: "Africa",
    coordinates: [-7.0926, 31.7917],
    flag: "🇲🇦",
    officeType: "regional",
    population: "37.5 million",
    status: "planned"
  },
  {
    id: "315",
    name: "Mozambique",
    type: "country",
    continent: "Africa",
    coordinates: [35.5296, -18.6657],
    flag: "🇲🇿",
    officeType: "regional",
    population: "32.8 million",
    status: "planned"
  },
  {
    id: "316",
    name: "Myanmar",
    type: "country",
    continent: "Asia",
    coordinates: [95.9560, 21.9162],
    flag: "🇲🇲",
    officeType: "regional",
    population: "54.4 million",
    status: "planned"
  },
  {
    id: "317",
    name: "Namibia",
    type: "country",
    continent: "Africa",
    coordinates: [18.4904, -22.9576],
    flag: "🇳🇦",
    officeType: "regional",
    population: "2.6 million",
    status: "planned"
  },
  {
    id: "318",
    name: "Nauru",
    type: "country",
    continent: "Oceania",
    coordinates: [166.9315, -0.5228],
    flag: "🇳🇷",
    officeType: "regional",
    population: "11,000",
    status: "planned"
  },
  {
    id: "319",
    name: "Nepal",
    type: "country",
    continent: "Asia",
    coordinates: [84.1240, 28.3949],
    flag: "🇳🇵",
    officeType: "regional",
    population: "30.0 million",
    status: "planned"
  },
  {
    id: "320",
    name: "Netherlands",
    type: "country",
    continent: "Europe",
    coordinates: [5.2913, 52.1326],
    flag: "🇳🇱",
    officeType: "regional",
    population: "17.4 million",
    status: "active"
  },
  {
    id: "321",
    name: "New Zealand",
    type: "country",
    continent: "Oceania",
    coordinates: [174.8860, -40.9006],
    flag: "🇳🇿",
    officeType: "regional",
    population: "5.1 million",
    status: "planned"
  },
  {
    id: "322",
    name: "Nicaragua",
    type: "country",
    continent: "North America",
    coordinates: [-85.2072, 12.8654],
    flag: "🇳🇮",
    officeType: "regional",
    population: "6.7 million",
    status: "planned"
  },
  {
    id: "323",
    name: "Niger",
    type: "country",
    continent: "Africa",
    coordinates: [8.0817, 17.6078],
    flag: "🇳🇪",
    officeType: "regional",
    population: "25.1 million",
    status: "planned"
  },
  {
    id: "324",
    name: "Nigeria",
    type: "country",
    continent: "Africa",
    coordinates: [8.6753, 9.0820],
    flag: "🇳🇬",
    officeType: "regional",
    population: "218 million",
    status: "planned"
  },
  {
    id: "325",
    name: "Niue",
    type: "territory",
    country: "New Zealand",
    continent: "Oceania",
    coordinates: [-169.8672, -19.0544],
    flag: "🇳🇺",
    officeType: "territorial",
    population: "1,600",
    status: "planned"
  },
  {
    id: "326",
    name: "Norfolk Island",
    type: "territory",
    country: "Australia",
    continent: "Oceania",
    coordinates: [167.9547, -29.0408],
    flag: "🇳🇫",
    officeType: "territorial",
    population: "1,750",
    status: "planned"
  },
  {
    id: "327",
    name: "North Korea",
    type: "country",
    continent: "Asia",
    coordinates: [127.5101, 40.3399],
    flag: "🇰🇵",
    officeType: "regional",
    population: "25.8 million",
    status: "planned"
  },
  {
    id: "328",
    name: "North Macedonia",
    type: "country",
    continent: "Europe",
    coordinates: [21.7453, 41.6086],
    flag: "🇲🇰",
    officeType: "regional",
    population: "2.1 million",
    status: "planned"
  },
  {
    id: "329",
    name: "Northern Mariana Islands",
    type: "territory",
    country: "United States",
    continent: "Oceania",
    coordinates: [145.3887, 17.3308],
    flag: "🇲🇵",
    officeType: "territorial",
    population: "47,000",
    status: "planned"
  },
  {
    id: "330",
    name: "Norway",
    type: "country",
    continent: "Europe",
    coordinates: [8.4689, 60.4720],
    flag: "🇳🇴",
    officeType: "regional",
    population: "5.5 million",
    status: "planned"
  },
  {
    id: "331",
    name: "Oman",
    type: "country",
    continent: "Asia",
    coordinates: [55.9754, 21.4735],
    flag: "🇴🇲",
    officeType: "regional",
    population: "5.3 million",
    status: "planned"
  },
  {
    id: "332",
    name: "Pakistan",
    type: "country",
    continent: "Asia",
    coordinates: [69.3451, 30.3753],
    flag: "🇵🇰",
    officeType: "regional",
    population: "231.4 million",
    status: "planned"
  },
  {
    id: "333",
    name: "Palau",
    type: "country",
    continent: "Oceania",
    coordinates: [134.5825, 7.5149],
    flag: "🇵🇼",
    officeType: "regional",
    population: "18,000",
    status: "planned"
  },
  {
    id: "334",
    name: "Panama",
    type: "country",
    continent: "North America",
    coordinates: [-80.7821, 8.5379],
    flag: "🇵🇦",
    officeType: "regional",
    population: "4.4 million",
    status: "planned"
  },
  {
    id: "335",
    name: "Papua New Guinea",
    type: "country",
    continent: "Oceania",
    coordinates: [143.9555, -6.3150],
    flag: "🇵🇬",
    officeType: "regional",
    population: "9.1 million",
    status: "planned"
  },
  {
    id: "336",
    name: "Paraguay",
    type: "country",
    continent: "South America",
    coordinates: [-58.4438, -23.4425],
    flag: "🇵🇾",
    officeType: "regional",
    population: "7.2 million",
    status: "planned"
  },
  {
    id: "337",
    name: "Peru",
    type: "country",
    continent: "South America",
    coordinates: [-75.0152, -9.1900],
    flag: "🇵🇪",
    officeType: "regional",
    population: "33.7 million",
    status: "planned"
  },
  {
    id: "338",
    name: "Philippines",
    type: "country",
    continent: "Asia",
    coordinates: [121.7740, 12.8797],
    flag: "🇵🇭",
    officeType: "regional",
    population: "113.9 million",
    status: "planned"
  },
  {
    id: "339",
    name: "Poland",
    type: "country",
    continent: "Europe",
    coordinates: [19.1451, 51.9194],
    flag: "🇵🇱",
    officeType: "regional",
    population: "38.0 million",
    status: "planned"
  },
  {
    id: "340",
    name: "Portugal",
    type: "country",
    continent: "Europe",
    coordinates: [-8.2245, 39.3999],
    flag: "🇵🇹",
    officeType: "regional",
    population: "10.3 million",
    status: "active"
  },
  {
    id: "341",
    name: "Puerto Rico",
    type: "territory",
    country: "United States",
    continent: "North America",
    coordinates: [-66.5901, 18.2208],
    flag: "🇵🇷",
    officeType: "territorial",
    population: "2.8 million",
    status: "planned"
  },
  {
    id: "342",
    name: "Qatar",
    type: "country",
    continent: "Asia",
    coordinates: [51.1839, 25.3548],
    flag: "🇶🇦",
    officeType: "regional",
    population: "2.9 million",
    status: "planned"
  },
  {
    id: "343",
    name: "RU Central Federal District",
    type: "federal_district",
    country: "Russia",
    continent: "Europe",
    coordinates: [37.6173, 55.7558],
    flag: "🇷🇺",
    officeType: "federal_district",
    population: "39.1 million",
    capital: "Moscow",
    status: "planned"
  },
  {
    id: "344",
    name: "RU Far Eastern Federal District",
    type: "federal_district",
    country: "Russia",
    continent: "Asia",
    coordinates: [132.0000, 61.0000],
    flag: "🇷🇺",
    officeType: "federal_district",
    population: "8.1 million",
    capital: "Vladivostok",
    status: "planned"
  },
  {
    id: "345",
    name: "RU North Caucasian Federal District",
    type: "federal_district",
    country: "Russia",
    continent: "Europe",
    coordinates: [43.0000, 44.0000],
    flag: "🇷🇺",
    officeType: "federal_district",
    population: "9.8 million",
    capital: "Pyatigorsk",
    status: "planned"
  },
  {
    id: "346",
    name: "RU Northwestern Federal District",
    type: "federal_district",
    country: "Russia",
    continent: "Europe",
    coordinates: [30.3351, 59.9311],
    flag: "🇷🇺",
    officeType: "federal_district",
    population: "13.9 million",
    capital: "Saint Petersburg",
    status: "planned"
  },
  {
    id: "347",
    name: "RU Siberian Federal District",
    type: "federal_district",
    country: "Russia",
    continent: "Asia",
    coordinates: [93.0000, 58.0000],
    flag: "🇷🇺",
    officeType: "federal_district",
    population: "17.1 million",
    capital: "Novosibirsk",
    status: "planned"
  },
  {
    id: "348",
    name: "RU Southern Federal District",
    type: "federal_district",
    country: "Russia",
    continent: "Europe",
    coordinates: [39.7000, 47.2300],
    flag: "🇷🇺",
    officeType: "federal_district",
    population: "16.5 million",
    capital: "Rostov-on-Don",
    status: "planned"
  },
  {
    id: "349",
    name: "RU Ural Federal District",
    type: "federal_district",
    country: "Russia",
    continent: "Asia",
    coordinates: [60.6122, 56.8431],
    flag: "🇷🇺",
    officeType: "federal_district",
    population: "12.4 million",
    capital: "Yekaterinburg",
    status: "planned"
  },
  {
    id: "350",
    name: "RU Volga Federal District",
    type: "federal_district",
    country: "Russia",
    continent: "Europe",
    coordinates: [50.1500, 53.2000],
    flag: "🇷🇺",
    officeType: "federal_district",
    population: "29.6 million",
    capital: "Nizhny Novgorod",
    status: "planned"
  },
  {
    id: "351",
    name: "Republic of Congo",
    type: "country",
    continent: "Africa",
    coordinates: [15.8277, -0.2280],
    flag: "🇨🇬",
    officeType: "regional",
    population: "5.7 million",
    status: "planned"
  },
  {
    id: "352",
    name: "Romania",
    type: "country",
    continent: "Europe",
    coordinates: [24.9668, 45.9432],
    flag: "🇷🇴",
    officeType: "regional",
    population: "19.2 million",
    status: "planned"
  },
  {
    id: "353",
    name: "Rwanda",
    type: "country",
    continent: "Africa",
    coordinates: [29.8739, -1.9403],
    flag: "🇷🇼",
    officeType: "regional",
    population: "13.5 million",
    status: "planned"
  },
  {
    id: "354",
    name: "SA Al Baha",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [41.4677, 20.0129],
    flag: "🇸🇦",
    officeType: "province",
    population: "476,000",
    capital: "Al Baha",
    status: "planned"
  },
  {
    id: "355",
    name: "SA Aseer",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [42.5000, 19.0000],
    flag: "🇸🇦",
    officeType: "province",
    population: "2.2 million",
    capital: "Abha",
    status: "planned"
  },
  {
    id: "356",
    name: "Saba",
    type: "territory",
    country: "Netherlands",
    continent: "North America",
    coordinates: [-63.2384, 17.6355],
    flag: "🇧🇶",
    officeType: "territorial",
    population: "2,000",
    status: "planned"
  },
  {
    id: "357",
    name: "Saint Helena",
    type: "territory",
    country: "United Kingdom",
    continent: "Africa",
    coordinates: [-5.7089, -15.9387],
    flag: "🇸🇭",
    officeType: "territorial",
    population: "6,000",
    status: "planned"
  },
  {
    id: "358",
    name: "Saint Maarten",
    type: "territory",
    country: "Netherlands",
    continent: "North America",
    coordinates: [-63.0501, 18.0425],
    flag: "🇸🇽",
    officeType: "territorial",
    population: "42,000",
    status: "planned"
  },
  {
    id: "359",
    name: "Saint Martin",
    type: "territory",
    country: "France",
    continent: "North America",
    coordinates: [-63.0501, 18.0708],
    flag: "🇲🇫",
    officeType: "territorial",
    population: "32,000",
    status: "planned"
  },
  {
    id: "360",
    name: "Saint Pierre and Miquelon",
    type: "territory",
    country: "France",
    continent: "North America",
    coordinates: [-56.1735, 46.8852],
    flag: "🇵🇲",
    officeType: "territorial",
    population: "6,000",
    status: "planned"
  },
  {
    id: "361",
    name: "Samoa",
    type: "country",
    continent: "Oceania",
    coordinates: [-172.1046, -13.7590],
    flag: "🇼🇸",
    officeType: "regional",
    population: "0.2 million",
    status: "planned"
  },
  {
    id: "362",
    name: "San Marino",
    type: "country",
    continent: "Europe",
    coordinates: [12.4578, 43.9424],
    flag: "🇸🇲",
    officeType: "regional",
    population: "34,000",
    status: "planned"
  },
  {
    id: "363",
    name: "Sint Eustatius",
    type: "territory",
    country: "Netherlands",
    continent: "North America",
    coordinates: [-62.9731, 17.4893],
    flag: "🇧🇶",
    officeType: "territorial",
    population: "3,200",
    status: "planned"
  },
  {
    id: "364",
    name: "South Africa",
    type: "country",
    continent: "Africa",
    coordinates: [24.9918, -28.8166],
    flag: "🇿🇦",
    officeType: "regional",
    population: "60.4 million",
    status: "active"
  },
  {
    id: "365",
    name: "South Korea",
    type: "country",
    continent: "Asia",
    coordinates: [127.7669, 35.9078],
    flag: "🇰🇷",
    officeType: "regional",
    population: "51.8 million",
    status: "planned"
  },
  {
    id: "366",
    name: "South Sudan",
    type: "country",
    continent: "Africa",
    coordinates: [31.3070, 6.8770],
    flag: "🇸🇸",
    officeType: "regional",
    population: "11.2 million",
    status: "planned"
  },
  {
    id: "367",
    name: "Sri Lanka",
    type: "country",
    continent: "Asia",
    coordinates: [80.7718, 7.8731],
    flag: "🇱🇰",
    officeType: "regional",
    population: "22.2 million",
    status: "planned"
  },
  {
    id: "368",
    name: "St Kitts and Nevis",
    type: "country",
    continent: "North America",
    coordinates: [-62.7830, 17.3578],
    flag: "🇰🇳",
    officeType: "regional",
    population: "53,000",
    status: "planned"
  },
  {
    id: "369",
    name: "St Lucia",
    type: "country",
    continent: "North America",
    coordinates: [-60.9789, 13.9094],
    flag: "🇱🇨",
    officeType: "regional",
    population: "0.2 million",
    status: "planned"
  },
  {
    id: "370",
    name: "St Vincent and the Grenadines",
    type: "country",
    continent: "North America",
    coordinates: [-61.2872, 13.1647],
    flag: "🇻🇨",
    officeType: "regional",
    population: "0.1 million",
    status: "planned"
  },
  {
    id: "371",
    name: "Sudan",
    type: "country",
    continent: "Africa",
    coordinates: [30.2176, 12.8628],
    flag: "🇸🇩",
    officeType: "regional",
    population: "44.9 million",
    status: "planned"
  },
  {
    id: "372",
    name: "Suriname",
    type: "country",
    continent: "South America",
    coordinates: [-56.0278, 3.9193],
    flag: "🇸🇷",
    officeType: "regional",
    population: "0.6 million",
    status: "planned"
  },
  {
    id: "373",
    name: "Svalbard",
    type: "territory",
    country: "Norway",
    continent: "Europe",
    coordinates: [19.1136, 78.2232],
    flag: "🇸🇯",
    officeType: "territorial",
    population: "2,650",
    status: "planned"
  },
  {
    id: "374",
    name: "Sweden",
    type: "country",
    continent: "Europe",
    coordinates: [18.6435, 60.1282],
    flag: "🇸🇪",
    officeType: "regional",
    population: "10.5 million",
    status: "planned"
  },
  {
    id: "375",
    name: "Switzerland",
    type: "country",
    continent: "Europe",
    coordinates: [8.2275, 46.8182],
    flag: "🇨🇭",
    officeType: "regional",
    population: "8.7 million",
    status: "planned"
  },
  {
    id: "376",
    name: "Syria",
    type: "country",
    continent: "Asia",
    coordinates: [38.9968, 34.8021],
    flag: "🇸🇾",
    officeType: "regional",
    population: "21.3 million",
    status: "planned"
  },
  {
    id: "377",
    name: "São Tomé and Príncipe",
    type: "country",
    continent: "Africa",
    coordinates: [6.6131, 0.1864],
    flag: "🇸🇹",
    officeType: "regional",
    population: "0.2 million",
    status: "planned"
  },
  {
    id: "378",
    name: "TR Aegean",
    type: "region",
    country: "Turkey",
    continent: "Asia",
    coordinates: [27.0000, 38.5000],
    flag: "🇹🇷",
    officeType: "region",
    population: "10.3 million",
    capital: "Izmir",
    status: "planned"
  },
  {
    id: "379",
    name: "TR Black Sea",
    type: "region",
    country: "Turkey",
    continent: "Asia",
    coordinates: [37.0000, 41.0000],
    flag: "🇹🇷",
    officeType: "region",
    population: "7.7 million",
    capital: "Samsun",
    status: "planned"
  },
  {
    id: "380",
    name: "TR Central Anatolia",
    type: "region",
    country: "Turkey",
    continent: "Asia",
    coordinates: [34.2500, 39.0000],
    flag: "🇹🇷",
    officeType: "region",
    population: "12.7 million",
    capital: "Ankara",
    status: "planned"
  },
  {
    id: "381",
    name: "TR Eastern Anatolia",
    type: "region",
    country: "Turkey",
    continent: "Asia",
    coordinates: [42.0000, 39.0000],
    flag: "🇹🇷",
    officeType: "region",
    population: "6.1 million",
    capital: "Erzurum",
    status: "planned"
  },
  {
    id: "382",
    name: "TR Marmara",
    type: "region",
    country: "Turkey",
    continent: "Europe",
    coordinates: [29.0000, 41.0000],
    flag: "🇹🇷",
    officeType: "region",
    population: "24.8 million",
    capital: "Istanbul",
    status: "planned"
  },
  {
    id: "383",
    name: "TR Mediterranean",
    type: "region",
    country: "Turkey",
    continent: "Asia",
    coordinates: [33.0000, 36.5000],
    flag: "🇴🇲",
    officeType: "region",
    population: "10.1 million",
    capital: "Antalya",
    status: "planned"
  },
  {
    id: "384",
    name: "TR Southeastern Anatolia",
    type: "region",
    country: "Turkey",
    continent: "Asia",
    coordinates: [40.0000, 37.5000],
    flag: "🇹🇷",
    officeType: "region",
    population: "8.6 million",
    capital: "Diyarbakir",
    status: "planned"
  },
  {
    id: "385",
    name: "Taiwan",
    type: "territory",
    country: "China",
    continent: "Asia",
    coordinates: [120.9605, 23.6978],
    flag: "🇹🇼",
    officeType: "territory",
    population: "23.8 million",
    status: "planned"
  },
  {
    id: "386",
    name: "Tajikistan",
    type: "country",
    continent: "Asia",
    coordinates: [71.2761, 38.8610],
    flag: "🇹🇯",
    officeType: "regional",
    population: "9.8 million",
    status: "planned"
  },
  {
    id: "387",
    name: "Tanzania",
    type: "country",
    continent: "Africa",
    coordinates: [34.8888, -6.3690],
    flag: "🇹🇿",
    officeType: "regional",
    population: "61.7 million",
    status: "planned"
  },
  {
    id: "388",
    name: "Thailand",
    type: "country",
    continent: "Asia",
    coordinates: [100.9925, 15.8700],
    flag: "🇹🇭",
    officeType: "regional",
    population: "69.8 million",
    status: "planned"
  },
  {
    id: "389",
    name: "The Bahamas",
    type: "country",
    continent: "North America",
    coordinates: [-77.3963, 25.0343],
    flag: "🇧🇸",
    officeType: "regional",
    population: "394,000",
    status: "planned"
  },
  {
    id: "390",
    name: "The Gambia",
    type: "country",
    continent: "Africa",
    coordinates: [-15.3101, 13.4432],
    flag: "🇬🇲",
    officeType: "regional",
    population: "2.5 million",
    status: "planned"
  },
  {
    id: "391",
    name: "Timor-Leste",
    type: "country",
    continent: "Asia",
    coordinates: [125.7275, -8.8742],
    flag: "🇹🇱",
    officeType: "regional",
    population: "1.3 million",
    status: "planned"
  },
  {
    id: "392",
    name: "Togo",
    type: "country",
    continent: "Africa",
    coordinates: [0.8248, 8.6195],
    flag: "🇹🇬",
    officeType: "regional",
    population: "8.6 million",
    status: "planned"
  },
  {
    id: "393",
    name: "Tokelau",
    type: "territory",
    country: "New Zealand",
    continent: "Oceania",
    coordinates: [-171.8484, -8.9673],
    flag: "🇹🇰",
    officeType: "territorial",
    population: "1,500",
    status: "planned"
  },
  {
    id: "394",
    name: "Tonga",
    type: "country",
    continent: "Oceania",
    coordinates: [-175.1982, -21.1790],
    flag: "🇹🇴",
    officeType: "regional",
    population: "0.1 million",
    status: "planned"
  },
  {
    id: "395",
    name: "Trinidad and Tobago",
    type: "country",
    continent: "North America",
    coordinates: [-61.2225, 10.6918],
    flag: "🇹🇹",
    officeType: "regional",
    population: "1.4 million",
    status: "planned"
  },
  {
    id: "396",
    name: "Tunisia",
    type: "country",
    continent: "Africa",
    coordinates: [9.5375, 33.8869],
    flag: "🇹🇳",
    officeType: "regional",
    population: "12.3 million",
    status: "planned"
  },
  {
    id: "397",
    name: "Turkmenistan",
    type: "country",
    continent: "Asia",
    coordinates: [59.5563, 38.9697],
    flag: "🇹🇲",
    officeType: "regional",
    population: "6.1 million",
    status: "planned"
  },
  {
    id: "398",
    name: "Turks and Caicos Islands",
    type: "territory",
    country: "United Kingdom",
    continent: "North America",
    coordinates: [-71.7979, 21.6940],
    flag: "🇹🇨",
    officeType: "territorial",
    population: "46,000",
    status: "planned"
  },
  {
    id: "399",
    name: "Tuvalu",
    type: "country",
    continent: "Oceania",
    coordinates: [179.1943, -7.1095],
    flag: "🇹🇻",
    officeType: "regional",
    population: "12,000",
    status: "planned"
  },
  {
    id: "400",
    name: "US Alabama",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-86.7916, 32.5328],
    flag: "🇺🇸",
    officeType: "state",
    population: "5.0 million",
    capital: "Montgomery",
    status: "planned"
  },
  {
    id: "401",
    name: "US Alaska",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-153.0000, 64.0685],
    flag: "🇺🇸",
    officeType: "state",
    population: "732,000",
    capital: "Juneau",
    status: "planned"
  },
  {
    id: "402",
    name: "US Arizona",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-111.4312, 34.0489],
    flag: "🇺🇸",
    officeType: "state",
    population: "7.4 million",
    capital: "Phoenix",
    status: "planned"
  },
  {
    id: "403",
    name: "US Arkansas",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-92.3731, 34.9513],
    flag: "🇺🇸",
    officeType: "state",
    population: "3.0 million",
    capital: "Little Rock",
    status: "planned"
  },
  {
    id: "404",
    name: "US California",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-119.4179, 36.7783],
    flag: "🇺🇸",
    officeType: "state",
    population: "39.5 million",
    capital: "Sacramento",
    status: "planned"
  },
  {
    id: "405",
    name: "US Colorado",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-105.3111, 39.0598],
    flag: "🇺🇸",
    officeType: "state",
    population: "5.8 million",
    capital: "Denver",
    status: "planned"
  },
  {
    id: "406",
    name: "US Connecticut",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-72.7554, 41.5978],
    flag: "🇺🇸",
    officeType: "state",
    population: "3.6 million",
    capital: "Hartford",
    status: "planned"
  },
  {
    id: "407",
    name: "US Delaware",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-75.5277, 39.3185],
    flag: "🇺🇸",
    officeType: "state",
    population: "990,000",
    capital: "Dover",
    status: "planned"
  },
  {
    id: "408",
    name: "US District of Columbia",
    type: "federal_district",
    country: "United States",
    continent: "North America",
    coordinates: [-77.0369, 38.9072],
    flag: "🇺🇸",
    officeType: "federal_district",
    population: "690,000",
    status: "planned"
  },
  {
    id: "409",
    name: "US Florida",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-81.5158, 27.7663],
    flag: "🇺🇸",
    officeType: "state",
    population: "22.6 million",
    capital: "Tallahassee",
    status: "planned"
  },
  {
    id: "410",
    name: "US Georgia",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-83.6431, 33.0406],
    flag: "🇺🇸",
    officeType: "state",
    population: "10.8 million",
    capital: "Atlanta",
    status: "planned"
  },
  {
    id: "411",
    name: "US Hawaii",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-157.8583, 21.0943],
    flag: "🇺🇸",
    officeType: "state",
    population: "1.4 million",
    capital: "Honolulu",
    status: "planned"
  },
  {
    id: "412",
    name: "US Idaho",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-114.4788, 44.2405],
    flag: "🇺🇸",
    officeType: "state",
    population: "1.9 million",
    capital: "Boise",
    status: "planned"
  },
  {
    id: "413",
    name: "US Illinois",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-88.9931, 40.3495],
    flag: "🇺🇸",
    officeType: "state",
    population: "12.6 million",
    capital: "Springfield",
    status: "planned"
  },
  {
    id: "414",
    name: "US Indiana",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-86.2604, 39.8494],
    flag: "🇺🇸",
    officeType: "state",
    population: "6.8 million",
    capital: "Indianapolis",
    status: "planned"
  },
  {
    id: "415",
    name: "US Iowa",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-93.6091, 42.0115],
    flag: "🇺🇸",
    officeType: "state",
    population: "3.2 million",
    capital: "Des Moines",
    status: "planned"
  },
  {
    id: "416",
    name: "US Kansas",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-96.7265, 38.5266],
    flag: "🇺🇸",
    officeType: "state",
    population: "2.9 million",
    capital: "Topeka",
    status: "planned"
  },
  {
    id: "417",
    name: "US Kentucky",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-84.6701, 37.6681],
    flag: "🇺🇸",
    officeType: "state",
    population: "4.5 million",
    capital: "Frankfort",
    status: "planned"
  },
  {
    id: "418",
    name: "US Louisiana",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-91.8259, 31.1695],
    flag: "🇺🇸",
    officeType: "state",
    population: "4.6 million",
    capital: "Baton Rouge",
    status: "planned"
  },
  {
    id: "419",
    name: "US Maine",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-69.3977, 44.6939],
    flag: "🇺🇸",
    officeType: "state",
    population: "1.4 million",
    capital: "Augusta",
    status: "planned"
  },
  {
    id: "420",
    name: "US Maryland",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-76.8021, 39.0639],
    flag: "🇺🇸",
    officeType: "state",
    population: "6.2 million",
    capital: "Annapolis",
    status: "planned"
  },
  {
    id: "421",
    name: "US Massachusetts",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-71.3824, 42.4072],
    flag: "🇺🇸",
    officeType: "state",
    population: "7.0 million",
    capital: "Boston",
    status: "planned"
  },
  {
    id: "422",
    name: "US Michigan",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-85.6024, 44.3148],
    flag: "🇺🇸",
    officeType: "state",
    population: "10.1 million",
    capital: "Lansing",
    status: "planned"
  },
  {
    id: "423",
    name: "US Minnesota",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-94.6859, 46.7296],
    flag: "🇺🇸",
    officeType: "state",
    population: "5.7 million",
    capital: "Saint Paul",
    status: "planned"
  },
  {
    id: "424",
    name: "US Mississippi",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-89.6787, 32.7673],
    flag: "🇺🇸",
    officeType: "state",
    population: "2.9 million",
    capital: "Jackson",
    status: "planned"
  },
  {
    id: "425",
    name: "US Missouri",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-92.4371, 38.3047],
    flag: "🇺🇸",
    officeType: "state",
    population: "6.2 million",
    capital: "Jefferson City",
    status: "planned"
  },
  {
    id: "426",
    name: "US Montana",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-110.3626, 46.8797],
    flag: "🇺🇸",
    officeType: "state",
    population: "1.1 million",
    capital: "Helena",
    status: "planned"
  },
  {
    id: "427",
    name: "US Nebraska",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-99.9018, 41.4925],
    flag: "🇺🇸",
    officeType: "state",
    population: "2.0 million",
    capital: "Lincoln",
    status: "planned"
  },
  {
    id: "428",
    name: "US Nevada",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-116.4194, 38.8026],
    flag: "🇺🇸",
    officeType: "state",
    population: "3.1 million",
    capital: "Carson City",
    status: "planned"
  },
  {
    id: "429",
    name: "US New Hampshire",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-71.5639, 43.4525],
    flag: "🇺🇸",
    officeType: "state",
    population: "1.4 million",
    capital: "Concord",
    status: "planned"
  },
  {
    id: "430",
    name: "US New Jersey",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-74.4057, 40.0583],
    flag: "🇺🇸",
    officeType: "state",
    population: "9.3 million",
    capital: "Trenton",
    status: "planned"
  },
  {
    id: "431",
    name: "US New Mexico",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-106.2485, 34.5199],
    flag: "🇺🇸",
    officeType: "state",
    population: "2.1 million",
    capital: "Santa Fe",
    status: "planned"
  },
  {
    id: "432",
    name: "US New York",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-74.2179, 43.2994],
    flag: "🇺🇸",
    officeType: "state",
    population: "20.2 million",
    capital: "Albany",
    status: "planned"
  },
  {
    id: "433",
    name: "US North Carolina",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-79.0193, 35.7596],
    flag: "🇺🇸",
    officeType: "state",
    population: "10.6 million",
    capital: "Raleigh",
    status: "planned"
  },
  {
    id: "434",
    name: "US North Dakota",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-101.0020, 47.5289],
    flag: "🇺🇸",
    officeType: "state",
    population: "0.8 million",
    capital: "Bismarck",
    status: "planned"
  },
  {
    id: "435",
    name: "US Ohio",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-82.9071, 40.4173],
    flag: "🇺🇸",
    officeType: "state",
    population: "11.8 million",
    capital: "Columbus",
    status: "planned"
  },
  {
    id: "436",
    name: "US Oklahoma",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-97.0929, 35.5653],
    flag: "🇺🇸",
    officeType: "state",
    population: "4.0 million",
    capital: "Oklahoma City",
    status: "planned"
  },
  {
    id: "437",
    name: "US Oregon",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-120.5542, 44.5720],
    flag: "🇺🇸",
    officeType: "state",
    population: "4.2 million",
    capital: "Salem",
    status: "planned"
  },
  {
    id: "438",
    name: "US Pennsylvania",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-77.1945, 41.2033],
    flag: "🇺🇸",
    officeType: "state",
    population: "13.0 million",
    capital: "Harrisburg",
    status: "planned"
  },
  {
    id: "439",
    name: "US Rhode Island",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-71.5118, 41.6809],
    flag: "🇺🇸",
    officeType: "state",
    population: "1.1 million",
    capital: "Providence",
    status: "planned"
  },
  {
    id: "440",
    name: "US South Carolina",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-81.1637, 33.8569],
    flag: "🇺🇸",
    officeType: "state",
    population: "5.3 million",
    capital: "Columbia",
    status: "planned"
  },
  {
    id: "441",
    name: "US South Dakota",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-99.9018, 44.2998],
    flag: "🇺🇸",
    officeType: "state",
    population: "0.9 million",
    capital: "Pierre",
    status: "planned"
  },
  {
    id: "442",
    name: "US Tennessee",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-86.5804, 35.5175],
    flag: "🇺🇸",
    officeType: "state",
    population: "7.1 million",
    capital: "Nashville",
    status: "planned"
  },
  {
    id: "443",
    name: "US Texas",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-99.9018, 31.9686],
    flag: "🇺🇸",
    officeType: "state",
    population: "29.5 million",
    capital: "Austin",
    status: "planned"
  },
  {
    id: "444",
    name: "US Utah",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-111.8624, 39.4998],
    flag: "🇺🇸",
    officeType: "state",
    population: "3.3 million",
    capital: "Salt Lake City",
    status: "planned"
  },
  {
    id: "445",
    name: "US Vermont",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-72.5778, 44.5588],
    flag: "🇺🇸",
    officeType: "state",
    population: "0.6 million",
    capital: "Montpelier",
    status: "planned"
  },
  {
    id: "446",
    name: "US Virgin Islands",
    type: "territory",
    country: "United States",
    continent: "North America",
    coordinates: [-64.8963, 17.7294],
    flag: "🇻🇮",
    officeType: "territorial",
    population: "87,000",
    status: "planned"
  },
  {
    id: "447",
    name: "US Virginia",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-78.6569, 37.4316],
    flag: "🇺🇸",
    officeType: "state",
    population: "8.7 million",
    capital: "Richmond",
    status: "planned"
  },
  {
    id: "448",
    name: "US Washington",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-120.7401, 47.7511],
    flag: "🇺🇸",
    officeType: "state",
    population: "7.7 million",
    capital: "Olympia",
    status: "planned"
  },
  {
    id: "449",
    name: "US West Virginia",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-80.9545, 38.5976],
    flag: "🇺🇸",
    officeType: "state",
    population: "1.8 million",
    capital: "Charleston",
    status: "planned"
  },
  {
    id: "450",
    name: "US Wisconsin",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-89.6165, 44.2685],
    flag: "🇺🇸",
    officeType: "state",
    population: "5.9 million",
    capital: "Madison",
    status: "planned"
  },
  {
    id: "451",
    name: "US Wyoming",
    type: "state",
    country: "United States",
    continent: "North America",
    coordinates: [-107.2903, 43.0750],
    flag: "🇺🇸",
    officeType: "state",
    population: "0.6 million",
    capital: "Cheyenne",
    status: "planned"
  },
  {
    id: "452",
    name: "Uganda",
    type: "country",
    continent: "Africa",
    coordinates: [32.2903, 1.3733],
    flag: "🇺🇬",
    officeType: "regional",
    population: "47.1 million",
    status: "planned"
  },
  {
    id: "453",
    name: "Ukraine",
    type: "country",
    continent: "Europe",
    coordinates: [31.1656, 48.3794],
    flag: "🇺🇦",
    officeType: "regional",
    population: "44.2 million",
    status: "planned"
  },
  {
    id: "454",
    name: "United Arab Emirates",
    type: "country",
    continent: "Asia",
    coordinates: [53.8478, 23.4241],
    flag: "🇦🇪",
    officeType: "regional",
    population: "10.0 million",
    status: "planned"
  },
  {
    id: "455",
    name: "United Kingdom",
    type: "country",
    continent: "Europe",
    coordinates: [-3.4360, 55.3781],
    flag: "🇬🇧",
    officeType: "regional",
    population: "67.3 million",
    status: "active"
  },
  {
    id: "456",
    name: "Uruguay",
    type: "country",
    continent: "South America",
    coordinates: [-55.7658, -32.5228],
    flag: "🇺🇾",
    officeType: "regional",
    population: "3.5 million",
    status: "planned"
  },
  {
    id: "457",
    name: "Uzbekistan",
    type: "country",
    continent: "Asia",
    coordinates: [64.5853, 41.3775],
    flag: "🇺🇿",
    officeType: "regional",
    population: "34.9 million",
    status: "planned"
  },
  {
    id: "458",
    name: "Vanuatu",
    type: "country",
    continent: "Oceania",
    coordinates: [166.9592, -15.3767],
    flag: "🇻🇺",
    officeType: "regional",
    population: "0.3 million",
    status: "planned"
  },
  {
    id: "459",
    name: "Vatican City",
    type: "country",
    continent: "Europe",
    coordinates: [12.4534, 41.9029],
    flag: "🇻🇦",
    officeType: "regional",
    population: "800",
    status: "planned"
  },
  {
    id: "460",
    name: "Venezuela",
    type: "country",
    continent: "South America",
    coordinates: [-66.5897, 6.4238],
    flag: "🇻🇪",
    officeType: "regional",
    population: "28.7 million",
    status: "planned"
  },
  {
    id: "461",
    name: "Vietnam",
    type: "country",
    continent: "Asia",
    coordinates: [108.2772, 14.0583],
    flag: "🇻🇳",
    officeType: "regional",
    population: "98.2 million",
    status: "planned"
  },
  {
    id: "462",
    name: "West Bank and Gaza",
    type: "territory",
    continent: "Asia",
    coordinates: [35.3026, 31.9466],
    flag: "🇵🇸",
    officeType: "territory",
    population: "5.3 million",
    status: "planned"
  },
  {
    id: "463",
    name: "Yemen",
    type: "country",
    continent: "Asia",
    coordinates: [48.5164, 15.5527],
    flag: "🇾🇪",
    officeType: "regional",
    population: "30.5 million",
    status: "planned"
  },
  {
    id: "464",
    name: "Zambia",
    type: "country",
    continent: "Africa",
    coordinates: [27.8493, -13.1339],
    flag: "🇿🇲",
    officeType: "regional",
    population: "19.6 million",
    status: "planned"
  },
  {
    id: "465",
    name: "Zimbabwe",
    type: "country",
    continent: "Africa",
    coordinates: [29.1549, -19.0154],
    flag: "🇿🇼",
    officeType: "regional",
    population: "15.1 million",
    status: "active"
  },
  {
    id: "466",
    name: "SA Eastern Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [49.5000, 26.5000],
    flag: "🇸🇦",
    officeType: "province",
    population: "4.9 million",
    capital: "Dammam",
    status: "planned"
  },
  {
    id: "467",
    name: "SA Ha'il Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [41.6907, 27.5219],
    flag: "🇸🇦",
    officeType: "province",
    population: "0.7 million",
    capital: "Ha'il",
    status: "planned"
  },
  {
    id: "468",
    name: "SA Jawf Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [40.0000, 29.5000],
    flag: "🇸🇦",
    officeType: "province",
    population: "0.5 million",
    capital: "Sakakah",
    status: "planned"
  },
  {
    id: "469",
    name: "SA Jizan Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [42.5511, 16.8893],
    flag: "🇸🇦",
    officeType: "province",
    population: "1.6 million",
    capital: "Jizan",
    status: "planned"
  },
  {
    id: "470",
    name: "SA Madinah Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [39.6142, 24.4686],
    flag: "🇸🇦",
    officeType: "province",
    population: "2.2 million",
    capital: "Medina",
    status: "planned"
  },
  {
    id: "471",
    name: "SA Makkah Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [39.8579, 21.4266],
    flag: "🇸🇦",
    officeType: "province",
    population: "8.6 million",
    capital: "Mecca",
    status: "planned"
  },
  {
    id: "472",
    name: "SA Najran Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [44.1277, 17.4924],
    flag: "🇸🇦",
    officeType: "province",
    population: "0.6 million",
    capital: "Najran",
    status: "planned"
  },
  {
    id: "473",
    name: "SA Northern Borders Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [42.0000, 30.0000],
    flag: "🇸🇦",
    officeType: "province",
    population: "0.4 million",
    capital: "Arar",
    status: "planned"
  },
  {
    id: "474",
    name: "SA Qassim Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [43.4837, 26.2078],
    flag: "🇸🇦",
    officeType: "province",
    population: "1.4 million",
    capital: "Buraydah",
    status: "planned"
  },
  {
    id: "475",
    name: "SA Riyadh Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [46.6753, 24.7136],
    flag: "🇸🇦",
    officeType: "province",
    population: "8.2 million",
    capital: "Riyadh",
    status: "planned"
  },
  {
    id: "476",
    name: "SA Tabuk Emirate",
    type: "province",
    country: "Saudi Arabia",
    continent: "Asia",
    coordinates: [36.5715, 28.3838],
    flag: "🇸🇦",
    officeType: "province",
    population: "0.9 million",
    capital: "Tabuk",
    status: "planned"
  },
  {
    id: "477",
    name: "Sierra Leone",
    type: "country",
    continent: "Africa",
    coordinates: [-11.7799, 8.4606],
    flag: "🇸🇱",
    officeType: "regional",
    population: "8.1 million",
    status: "planned"
  },
  {
    id: "479",
    name: "DE Baden wurtenberg",
    type: "state",
    country: "Germany",
    continent: "Europe",
    coordinates: [9.0000, 48.6616],
    flag: "🇩🇪",
    officeType: "state",
    population: "11.1 million",
    capital: "Stuttgart",
    status: "planned"
  },
  {
    id: "500",
    name: "SportsFuture Island",
    type: "headquarters",
    continent: "Atlantic",
    coordinates: [-35.0, 47.0],
    flag: "🏝️",
    officeType: "headquarters",
    population: "25",
    status: "active",
    isCustomIsland: true
  }
];

// Active offices (subset of locations with contact info)
// officer labels are generic (no hardcoded DID/identification numbers)
const activeOffices = [
  {
    id: "office_belgium",
    locationId: 16,
    officer: "Sports Officer",
    contactEmail: "belgium@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_curacao",
    locationId: 220,
    officer: "Sports Officer",
    contactEmail: "curacao@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_dominican",
    locationId: 221,
    officer: "Sports Officer",
    contactEmail: "dominican@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_ireland",
    locationId: 203,
    officer: "Sports Officer",
    contactEmail: "ireland@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_netherlands",
    locationId: 204,
    officer: "Sports Officer",
    contactEmail: "netherlands@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_portugal_1",
    locationId: 205,
    officer: "Sports Officer",
    contactEmail: "portugal1@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_portugal_2",
    locationId: 205,
    officer: "Sports Officer",
    contactEmail: "portugal2@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_scotland",
    locationId: 182,
    officer: "Sports Officer",
    contactEmail: "scotland@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_south_africa_1",
    locationId: 250,
    officer: "Sports Officer",
    contactEmail: "southafrica1@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_south_africa_2",
    locationId: 250,
    officer: "Sports Officer",
    contactEmail: "southafrica2@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_south_africa_3",
    locationId: 250,
    officer: "Sports Officer",
    contactEmail: "southafrica3@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_south_africa_4",
    locationId: 250,
    officer: "Sports Officer",
    contactEmail: "southafrica4@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_south_africa_5",
    locationId: 250,
    officer: "Sports Officer",
    contactEmail: "southafrica5@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_south_africa_6",
    locationId: 250,
    officer: "Sports Officer",
    contactEmail: "southafrica6@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_uk_1",
    locationId: 181,
    officer: "Sports Officer",
    contactEmail: "uk1@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_uk_2",
    locationId: 181,
    officer: "Sports Officer",
    contactEmail: "uk2@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_uk_3",
    locationId: 181,
    officer: "Sports Officer",
    contactEmail: "uk3@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_uk_4",
    locationId: 181,
    officer: "Sports Officer",
    contactEmail: "uk4@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_zimbabwe_1",
    locationId: 478,
    officer: "Sports Officer",
    contactEmail: "zimbabwe1@sportsfuture.com",
    established: "2024"
  },
  {
    id: "office_zimbabwe_2",
    locationId: 478,
    officer: "Sports Officer",
    contactEmail: "zimbabwe2@sportsfuture.com",
    established: "2024"
  }
];

// Helper functions
const getLocationById = (id) => {
  return allLocations.find(location => location.id === id);
};

const getActiveOfficesByLocationId = (locationId) => {
  return activeOffices.filter(office => office.locationId === locationId);
};

const getLocationsByContinent = (continent) => {
  return allLocations.filter(location => location.continent === continent);
};

const getLocationsByType = (type) => {
  return allLocations.filter(location => location.type === type);
};

const getLocationsByCountry = (country) => {
  return allLocations.filter(location => location.country === country);
};

const getLocationsByStatus = (status) => {
  return allLocations.filter(location => location.status === status);
};

const searchLocations = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return allLocations.filter(location => 
    location.name.toLowerCase().includes(term) ||
    location.continent.toLowerCase().includes(term) ||
    (location.country && location.country.toLowerCase().includes(term))
  );
};

// Export all data and functions
export {
  allLocations,
  activeOffices,
  getLocationById,
  getActiveOfficesByLocationId,
  getLocationsByContinent,
  getLocationsByType,
  getLocationsByCountry,
  getLocationsByStatus,
  searchLocations
};
